(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["plate-customizer"] && !Shopify.designMode) return;
  try {
    
  const PLATE_KEEP_SYMBOLS = ['©', '®', '™'];

  const PLATE_EMOJI_RE = (function () {
    try {
      return new RegExp(
        '(?:\\p{Extended_Pictographic}|\\p{Emoji_Modifier}|\\p{Regional_Indicator})' +
          '[\\uFE0E\\uFE0F\\u20E3]*' +
          '|[\\uFE0F\\u200D\\u20E3]',
        'gu'
      );
    } catch (e) {
      return /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27BF\u2B00-\u2BFF\uFE0E\uFE0F\u200D\u20E3]/g;
    }
  })();

  function stripPlateEmoji(value) {
    const input = value == null ? '' : String(value);
    if (!input) return '';
    return input.replace(PLATE_EMOJI_RE, (match) => {
      const bare = match.replace(/[\uFE0E\uFE0F]/g, '');
      return PLATE_KEEP_SYMBOLS.indexOf(bare) !== -1 ? bare : '';
    });
  }


  /* ---- Revisão de texto (script local, sem serviço externo) ---- */

  // O dicionário pt-BR (assets/plate-review-pt-br.js, gerado a partir do VERO + frequência de uso) é carregado
  // sob demanda no primeiro clique em "Revisar texto" e expõe window.PlateReviewDictionary = { words, top }.
  // A partir dele o script monta:
  //   known   -> Set de palavras válidas (com acento);
  //   foldMap -> forma sem acento -> palavra válida preferida (a mais frequente);
  //   rank    -> palavra -> posição por frequência (menor = mais comum), só para as mais usadas;
  //   prefer  -> palavra válida sem acento cuja forma acentuada é muito mais usada (policia -> polícia,
  //              publico -> público); calculado na geração do dicionário, sem as ambíguas (esta/está, e/é);
  //   phon    -> "chave de som" -> palavras válidas com essa pronúncia (fexar/fechar, seguransa/segurança);
  //   signage -> vocabulário típico de placas, preferido entre candidatos (chão antes de chau).
  // Regras de correção de cada palavra (plateReviewWord):
  //   1) regras do lojista ("errado:certo" e palavras marcadas como corretas);
  //   2) abreviações/erros fixos (PLATE_REVIEW_ABBREV);
  //   3) palavra válida: não muda (exceto as de `prefer`, que recebem a forma acentuada usual);
  //      Homófonos válidos que em placas quase sempre são erro (sinto/cinto, acento/assento, sesta/sexta)
  //      estão listados à mão em PLATE_REVIEW_ABBREV, com exceções de contexto em PLATE_REVIEW_KEEP;
  //   4) igual a uma palavra válida ignorando acentos: corrige o acento (policia -> polícia, nao -> não);
  //   5) desconhecida com 3+ letras: palavra válida com a mesma chave de som (fexar -> fechar,
  //      seguransa -> segurança, oje -> hoje), vocabulário de placas primeiro, depois a mais frequente;
  //   6) desconhecida com 4+ letras: palavra válida a 1 edição de distância (2 a partir de 9 letras),
  //      vocabulário de placas primeiro, depois a mais frequente (degral -> degrau, pexe -> peixe).
  //      Empate entre palavras raras = não corrige.
  // Tokens com número, siglas curtas e palavras de até 4 letras desconhecidas nunca são alteradas.

  const PLATE_REVIEW_ABBREV = {
    naum: 'não', 'ñ': 'não', eh: 'é', vc: 'você', vcs: 'vocês', pra: 'para', tb: 'também', tbm: 'também',
    qdo: 'quando', qto: 'quanto', hj: 'hoje', mto: 'muito', mta: 'muita', menas: 'menos', seje: 'seja',
    'á': 'à', sab: 'sáb', alugase: 'aluga-se', vendese: 'vende-se', precisase: 'precisa-se', procurase: 'procura-se',
    benvindo: 'bem-vindo', benvinda: 'bem-vinda', benvindos: 'bem-vindos', benvindas: 'bem-vindas',
    excessao: 'exceção', excessão: 'exceção', previlegio: 'privilégio', previlégio: 'privilégio',
    propietario: 'proprietário', propietarios: 'proprietários', compania: 'companhia', assessorios: 'acessórios',
    probido: 'proibido', pobido: 'proibido', pize: 'pise', pizar: 'pisar',
    // homófonos válidos que em placas são quase sempre erro
    sinto: 'cinto', sintos: 'cintos', acento: 'assento', acentos: 'assentos', sesta: 'sexta', sestas: 'sextas',
    aceso: 'acesso', acesos: 'acessos', azougue: 'açougue', cegada: 'chegada', cegadas: 'chegadas',
    aki: 'aqui', oje: 'hoje', pexe: 'peixe', pexes: 'peixes',
  };

  // Contextos em que a palavra NÃO deve ser trocada mesmo estando em PLATE_REVIEW_ABBREV.
  const PLATE_REVIEW_KEEP = [/\bsinto (muito|falta|que|me|isso|saudade)\b/gi, /\beu sinto\b/gi, /\bconcerto\b/gi];

  // Regras de frase para casos que dependem do contexto. `to` usa $1, $2… dos grupos.
  const PLATE_REVIEW_PHRASES = [
    { re: /\be (proibid[oa]s?|obrigat[oó]ri[oa]s?|permitid[oa]s?|expressamente|terminantemente)\b/gi, to: 'é $1' },
    { re: /\besta (proibid[oa]s?|fechad[oa]s?|abert[oa]s?|interditad[oa]s?|reservad[oa]s?|ocupad[oa]s?|livre|sendo|fora de|em (?:manutencao|manutenção|obras|reforma))\b/gi, to: 'está $1' },
    { re: /\b(nao|não) ha\b/gi, to: '$1 há' },
    { re: /\bha (vagas?|caes|cães|cao|cão|risco|perigo|cameras|câmeras)\b/gi, to: 'há $1' },
    { re: /\bas (?=\d)/gi, to: 'às ' },
    { re: /\b(aluga|vende|precisa|procura|troca|conserta|compra|vendem|alugam)[ -]+se\b/gi, to: '$1-se' },
    { re: /\bbem[ -]?(vind[oa]s?)\b/gi, to: 'bem-$1' },
  ];

  const PLATE_REVIEW_ALPHABET = 'abcdefghijklmnopqrstuvwxyz';

  const PLATE_REVIEW_TOKEN_RE = (function () {
    try {
      return new RegExp('[\\p{L}\\p{N}]+(?:-[\\p{L}\\p{N}]+)*', 'gu');
    } catch (e) {
      return /[A-Za-z0-9\u00C0-\u024F]+(?:-[A-Za-z0-9\u00C0-\u024F]+)*/g;
    }
  })();

  const PLATE_REVIEW_NON_LETTER_RE = (function () {
    try {
      return new RegExp('[^\\p{L}]', 'gu');
    } catch (e) {
      return /[^A-Za-z\u00C0-\u024F]/g;
    }
  })();

  const PLATE_REVIEW_DUP_WORD_RE = (function () {
    try {
      return new RegExp('\\b(\\p{L}{2,}) \\1\\b', 'giu');
    } catch (e) {
      return null;
    }
  })();

  // minúsculas + sem acento/cedilha, para comparar palavras.
  function plateReviewFold(value) {
    let s = String(value || '').toLowerCase();
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {
      /* sem normalize: compara como está */
    }
    return s;
  }

  // "Chave de som" aproximada do português: iguala grafias que soam igual (ch/x, ç/ss/c(e,i)/s/z, g(e,i)/j,
  // qu/c(a,o,u)/k, h mudo, m/n e l/u finais, letras dobradas). Só consoantes: vogais ficam como estão para não
  // juntar palavras diferentes (meu/meio, passei/passe).
  function plateReviewPhoneticKey(word) {
    let s = String(word || '').toLowerCase().replace(/ç/g, 's');
    s = plateReviewFold(s);
    s = s.replace(/ph/g, 'f').replace(/ch/g, 'x').replace(/lh/g, 'L').replace(/nh/g, 'N').replace(/h/g, '');
    s = s.replace(/sc(?=[ei])/g, 's').replace(/xc(?=[ei])/g, 's');
    s = s.replace(/qu(?=[ei])/g, 'k').replace(/gu(?=[ei])/g, 'g').replace(/q/g, 'k');
    s = s.replace(/c(?=[ei])/g, 's').replace(/c/g, 'k');
    s = s.replace(/g(?=[ei])/g, 'j');
    s = s.replace(/z/g, 's').replace(/y/g, 'i').replace(/w/g, 'u');
    s = s.replace(/m$/, 'n').replace(/l$/, 'u');
    s = s.replace(/(.)\1+/g, '$1');
    return s;
  }

  // Chaves alternativas: "x" também pode soar "s" (sexta, próximo).
  function plateReviewPhoneticKeys(word) {
    const key = plateReviewPhoneticKey(word);
    const keys = [key];
    if (key.indexOf('x') !== -1) {
      const alt = key.replace(/x/g, 's').replace(/(.)\1+/g, '$1');
      if (alt !== key) keys.push(alt);
    }
    return keys;
  }

  let plateReviewDict = null;

  // Decodifica window.PlateReviewDictionary (uma vez) nas estruturas usadas pela correção.
  function buildPlateReviewDictionary(raw) {
    if (plateReviewDict) return plateReviewDict;
    if (!raw || typeof raw.words !== 'string') return null;
    const known = new Set();
    const rank = new Map();
    const foldMap = new Map();
    const prefer = new Map();
    String(raw.prefer || '').split('\n').forEach((line) => {
      const idx = line.indexOf(':');
      if (idx > 0) prefer.set(line.slice(0, idx), line.slice(idx + 1));
    });
    const signage = new Set(String(raw.signage || '').split('\n').filter(Boolean));
    const phon = new Map();
    const lines = raw.words.split('\n');
    let prev = '';
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (!line) continue;
      const k = line.charCodeAt(0) - 48;
      const word = prev.slice(0, k) + line.slice(1);
      prev = word;
      known.add(word);
    }
    String(raw.top || '').split('\n').forEach((word, index) => {
      if (word && !rank.has(word)) rank.set(word, index);
    });
    const better = (a, b) => {
      // prefere a forma sem acento se ela própria é válida; depois a mais frequente
      const ra = rank.has(a) ? rank.get(a) : Infinity;
      const rb = rank.has(b) ? rank.get(b) : Infinity;
      return ra <= rb ? a : b;
    };
    known.forEach((word) => {
      plateReviewPhoneticKeys(word).forEach((key) => {
        const bucket = phon.get(key);
        if (bucket) bucket.push(word);
        else phon.set(key, [word]);
      });
      const folded = plateReviewFold(word);
      if (folded === word) {
        foldMap.set(folded, word);
        return;
      }
      const current = foldMap.get(folded);
      if (!current) foldMap.set(folded, word);
      else if (plateReviewFold(current) !== current) foldMap.set(folded, better(current, word));
    });
    plateReviewDict = { known, rank, foldMap, prefer, phon, signage };
    return plateReviewDict;
  }

  // Todas as strings a 1 edição de distância (Norvig).
  function plateReviewEdits1(word) {
    const out = new Set();
    const n = word.length;
    for (let i = 0; i <= n; i++) {
      const a = word.slice(0, i);
      const b = word.slice(i);
      if (b) out.add(a + b.slice(1));
      if (b.length > 1) out.add(a + b.charAt(1) + b.charAt(0) + b.slice(2));
      for (let c = 0; c < PLATE_REVIEW_ALPHABET.length; c++) {
        const ch = PLATE_REVIEW_ALPHABET.charAt(c);
        if (b) out.add(a + ch + b.slice(1));
        out.add(a + ch + b);
      }
    }
    return out;
  }

  // Palavra válida mais provável para uma palavra desconhecida (já sem acento), ou null.
  function plateReviewClosest(folded, dict) {
    const len = folded.length;
    if (len < 4) return null;
    const collect = (candidates, distance) => {
      const found = [];
      candidates.forEach((cand) => {
        if (cand !== folded && dict.foldMap.has(cand)) {
          const word = dict.foldMap.get(cand);
          found.push({ word, distance, rank: dict.rank.has(word) ? dict.rank.get(word) : Infinity });
        }
      });
      return found;
    };
    const edits1 = plateReviewEdits1(folded);
    let found = collect(edits1, 1);
    if (!found.length && len >= 9) {
      const edits2 = new Set();
      edits1.forEach((e1) => {
        plateReviewEdits1(e1).forEach((e2) => edits2.add(e2));
      });
      found = collect(edits2, 2);
    }
    if (!found.length) return null;
    const ordered = plateReviewSortCandidates(found.map((f) => f.word), dict);
    const best = ordered[0];
    if (len < 5 && !dict.signage.has(best)) return null;
    // vários candidatos e o melhor não está entre as palavras frequentes: incerto demais.
    if (ordered.length > 1 && !dict.signage.has(best) && plateReviewRankOf(dict, best) === Infinity) return null;
    return best;
  }

  const plateReviewRankOf = (dict, word) => (dict.rank.has(word) ? dict.rank.get(word) : Infinity);

  // Ordena candidatos: vocabulário de placas primeiro, depois os mais frequentes.
  function plateReviewSortCandidates(words, dict) {
    return words.slice().sort((a, b) => {
      const sa = dict.signage.has(a) ? 0 : 1;
      const sb = dict.signage.has(b) ? 0 : 1;
      return sa - sb || plateReviewRankOf(dict, a) - plateReviewRankOf(dict, b) || a.localeCompare(b);
    });
  }

  // Palavra desconhecida: palavra válida com a mesma chave de som (fexar -> fechar), ou null.
  function plateReviewPhonetic(word, dict) {
    if (word.length < 3) return null;
    const keys = plateReviewPhoneticKeys(word);
    for (let i = 0; i < keys.length; i++) {
      const bucket = dict.phon.get(keys[i]);
      if (!bucket || !bucket.length) continue;
      const options = plateReviewSortCandidates(bucket, dict);
      const best = options[0];
      const bestRank = plateReviewRankOf(dict, best);
      if (word.length < 4 && !dict.signage.has(best) && bestRank > 5000) return null;
      if (!dict.signage.has(best) && options.length > 1 && bestRank === Infinity) return null;
      return best;
    }
    return null;
  }

  // Aplica ao texto corrigido o padrão de caixa do texto original (TUDO MAIÚSCULO / Capitalizado / minúsculo).
  function plateReviewMatchCase(source, replacement) {
    const letters = source.replace(PLATE_REVIEW_NON_LETTER_RE, '');
    if (letters && letters === letters.toUpperCase() && letters !== letters.toLowerCase()) {
      return replacement.toUpperCase();
    }
    const first = source.charAt(0);
    if (first && first === first.toUpperCase() && first !== first.toLowerCase()) {
      return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }
    return replacement;
  }

  // Espaçamento e pontuação: espaços duplicados, espaço antes de pontuação, falta de espaço depois,
  // pontuação repetida e palavra duplicada.
  function plateReviewFormat(text) {
    let out = String(text || '');
    out = out.replace(/\r\n?/g, '\n').replace(/[ \t]+/g, ' ').replace(/ ?\n ?/g, '\n');
    out = out.replace(/ +([,.;:!?])/g, '$1');
    out = out.replace(/([,;!?])(?=[^\s\d,;!?.:)\]])/g, '$1 ');
    out = out.replace(/([!?])\1+/g, '$1').replace(/,{2,}/g, ',');
    if (PLATE_REVIEW_DUP_WORD_RE) out = out.replace(PLATE_REVIEW_DUP_WORD_RE, '$1');
    return out.trim();
  }

  function plateReviewWord(token, rules, dict) {
    if (/\d/.test(token)) return token;
    const lower = token.toLowerCase();
    const folded = plateReviewFold(lower);
    let target = null;
    if (rules && Object.prototype.hasOwnProperty.call(rules.map, lower)) {
      target = rules.map[lower];
    } else if (rules && Object.prototype.hasOwnProperty.call(rules.known, folded)) {
      return token;
    } else if (Object.prototype.hasOwnProperty.call(PLATE_REVIEW_ABBREV, lower)) {
      target = PLATE_REVIEW_ABBREV[lower];
    } else if (!dict) {
      return token;
    } else if (lower.indexOf('-') !== -1) {
      // palavra composta: corrige só o acento de cada parte
      const parts = lower.split('-').map((part) => {
        if (dict.known.has(part)) return part;
        const f = plateReviewFold(part);
        return dict.foldMap.has(f) ? dict.foldMap.get(f) : part;
      });
      target = parts.join('-');
      if (target === lower) return token;
    } else if (dict.prefer.has(lower)) {
      target = dict.prefer.get(lower);
    } else if (dict.known.has(lower)) {
      return token;
    } else if (dict.foldMap.has(folded)) {
      target = dict.foldMap.get(folded);
      if (dict.prefer.has(target)) target = dict.prefer.get(target);
      if (target === lower) return token;
    } else {
      target = plateReviewPhonetic(lower, dict) || plateReviewClosest(folded, dict);
      if (!target) return token;
      if (dict.prefer.has(target)) target = dict.prefer.get(target);
    }
    return plateReviewMatchCase(token, target);
  }

  function reviewPlateText(text, rules, dict) {
    const changes = [];
    const seen = {};
    const note = (from, to) => {
      const key = (from + '>' + to).toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      changes.push({ from, to });
    };

    let out = String(text || '');

    PLATE_REVIEW_PHRASES.forEach((rule) => {
      out = out.replace(rule.re, function (match) {
        const groups = Array.prototype.slice.call(arguments, 1, -2);
        let repl = rule.to.replace(/\$(\d)/g, (m, n) => groups[parseInt(n, 10) - 1] || '');
        repl = plateReviewMatchCase(match, repl);
        if (repl !== match) note(match.trim(), repl.trim());
        return repl;
      });
    });

    // trechos protegidos (ex.: "sinto muito"): nenhuma palavra dentro deles é alterada
    const keep = [];
    PLATE_REVIEW_KEEP.forEach((re) => {
      re.lastIndex = 0;
      let m;
      while ((m = re.exec(out)) !== null) {
        keep.push([m.index, m.index + m[0].length]);
        if (!re.global) break;
      }
    });
    out = out.replace(PLATE_REVIEW_TOKEN_RE, (token, offset) => {
      for (let i = 0; i < keep.length; i++) {
        if (offset >= keep[i][0] && offset < keep[i][1]) return token;
      }
      const repl = plateReviewWord(token, rules, dict);
      if (repl !== token) note(token, repl);
      return repl;
    });

    const formatted = plateReviewFormat(out);
    return { revised: formatted, changes, formatChanged: formatted !== out.trim() };
  }

  class PlateCustomizer extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.productFormId = this.dataset.productFormId;
      this.optionNames = {
        size: this.dataset.optionSize,
        material: this.dataset.optionMaterial,
        fixacao: this.dataset.optionFixacao,
      };
      this.maxText = parseInt(this.dataset.maxTextChars, 10) || 150;
      this.maxIcons = parseInt(this.dataset.maxIcons, 10) || 6;

      this.review = { status: 'idle', original: '', revised: '', notes: '' };
      this.reviewRules = null;
      this.reviewDictUrl = (this.dataset.reviewDictUrl || '').trim();
      this.reviewDictPromise = null;

      this.products = {};
      this.icons = [];
      this.modelMeta = {};
      this.backSvgsMap = [];
      this.currency = { showCurrencyCode: false, currencyCode: 'BRL' };

      this.stepOrder = ['design', 'size', 'material'];
      this.currentStep = 'design';
      this.purchased = false;

      this.state = {
        size: null,
        material: null,
        fixacao: null,
        modelHandle: this.dataset.initialProductHandle,
        text: '',
        category: '*',
        selectedIcons: [],
      };
      this._iconUid = 0;
    }

    connectedCallback() {
      this.loadData();
      this.cacheElements();
      this.bindEvents();
      this.initState();
      this.updateOptionAvailability();
      this.renderIcons();
      this.refreshPreview();
      this.refreshVariant();
      this.updateStepIndicator();
      this.updateFooter();
      this.setupModelsCarousel();
      this.setupModelImages();
      this.setupIconsScrollFade();
      this.hydrateCategoriesFromStorefront();
      this.hydrateIconsFromStorefront();
    }

    loadData() {
      this.querySelectorAll('[data-product-data]').forEach((tag) => {
        try {
          const data = JSON.parse(tag.textContent);
          this.products[data.handle] = data;
        } catch (e) {
          console.error('PlateCustomizer: invalid product data', e);
        }
      });

      const iconsTag = this.querySelector('[data-icons]');
      if (iconsTag) {
        try {
          this.icons = JSON.parse(iconsTag.textContent).filter((i) => i.active !== false);
          this.icons.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
        } catch (e) {
          this.icons = [];
        }
      }

      const metaTag = this.querySelector('[data-models-meta]');
      if (metaTag) {
        try {
          const list = JSON.parse(metaTag.textContent) || [];
          list.forEach((m) => {
            this.modelMeta[m.handle] = m;
          });
        } catch (e) {
          this.modelMeta = {};
        }
      }

      const backMapTag = this.querySelector('[data-back-svgs-map]');
      if (backMapTag) {
        try {
          this.backSvgsMap = JSON.parse(backMapTag.textContent) || [];
        } catch (e) {
          this.backSvgsMap = [];
        }
      }

      const currencyTag = this.querySelector('[data-currency-format]');
      if (currencyTag) {
        try {
          this.currency = Object.assign(this.currency, JSON.parse(currencyTag.textContent));
        } catch (e) {}
      }
    }

    async fetchAllMetaobjects(type) {
      const token = this.dataset.storefrontToken;
      if (!token || !type) return null;

      const version = this.dataset.storefrontVersion || '2025-01';
      const endpoint = '/api/' + version + '/graphql.json';
      const query =
        'query GetMetaobjects($type: String!, $cursor: String) {' +
        '  metaobjects(type: $type, first: 250, after: $cursor) {' +
        '    edges {' +
        '      cursor' +
        '      node {' +
        '        handle' +
        '        fields { key value reference { ... on Metaobject { handle } } }' +
        '      }' +
        '    }' +
        '    pageInfo { hasNextPage endCursor }' +
        '  }' +
        '}';

      const nodes = [];
      let cursor = null;
      let safety = 20;

      try {
        while (safety > 0) {
          safety -= 1;
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Shopify-Storefront-Access-Token': token,
            },
            body: JSON.stringify({ query, variables: { type, cursor } }),
          });
          if (!response.ok) {
            console.warn('[plate-customizer] Storefront API HTTP', response.status, 'for', type);
            return null;
          }
          const payload = await response.json();
          if (payload.errors) {
            console.warn('[plate-customizer] Storefront API errors for', type, payload.errors);
            return null;
          }
          const meta = payload.data && payload.data.metaobjects;
          if (!meta) {
            console.warn('[plate-customizer] Resposta sem data.metaobjects para', type, payload);
            return null;
          }
          meta.edges.forEach((edge) => nodes.push(edge.node));
          if (!meta.pageInfo || !meta.pageInfo.hasNextPage) break;
          cursor = meta.pageInfo.endCursor;
        }
      } catch (err) {
        console.warn('[plate-customizer] Storefront API failed for', type, err);
        return null;
      }

      return nodes;
    }

    async hydrateIconsFromStorefront() {
      const type = this.dataset.iconMetaobjectType || 'placa_icone';
      const nodes = await this.fetchAllMetaobjects(type);
      if (!nodes || nodes.length === 0) return;

      const incoming = [];
      nodes.forEach((node) => {
        const parsed = this.parseStorefrontIcon(node);
        if (parsed) incoming.push(parsed);
      });
      if (incoming.length === 0) return;

      const byHandle = new Map();
      this.icons.forEach((icon) => byHandle.set(icon.handle, icon));
      incoming.forEach((icon) => {
        if (icon.svg) this.ensureIconTemplate(icon);
        const existing = byHandle.get(icon.handle);
        if (existing) {
          existing.name = icon.name || existing.name;
          existing.friendlyName = icon.friendlyName || existing.friendlyName;
          if (icon.category) existing.category = icon.category;
          existing.sortOrder = icon.sortOrder || existing.sortOrder;
          existing.active = icon.active !== undefined ? icon.active : existing.active;
        } else if (icon.active !== false) {
          byHandle.set(icon.handle, icon);
        }
      });

      this.icons = Array.from(byHandle.values()).filter((icon) => icon.active !== false);
      this.icons.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      this.renderIcons();
    }

    async hydrateCategoriesFromStorefront() {
      const type = this.dataset.categoryMetaobjectType || 'placa_icone_categoria';
      const select = this.querySelector('[data-input-categoria]');
      if (!select) return;
      const nodes = await this.fetchAllMetaobjects(type);
      if (!nodes || nodes.length === 0) return;

      const existing = new Set(
        Array.from(select.options).map((opt) => opt.value)
      );
      let added = 0;
      nodes.forEach((node) => {
        if (!node || !node.handle) return;
        if (existing.has(node.handle)) return;
        const fields = {};
        (node.fields || []).forEach((field) => {
          fields[field.key] = field.value;
        });
        const label = fields.name || node.handle;
        const option = document.createElement('option');
        option.value = node.handle;
        option.textContent = label;
        select.appendChild(option);
        existing.add(node.handle);
        added += 1;
      });

      if (added === 0) return;

      const fixedFirst = select.options[0];
      const rest = Array.from(select.options).slice(1);
      rest.sort((a, b) => a.textContent.localeCompare(b.textContent, 'pt-BR'));
      select.innerHTML = '';
      select.appendChild(fixedFirst);
      rest.forEach((opt) => select.appendChild(opt));
      if (this.state && this.state.category) {
        select.value = this.state.category;
      }
    }

    parseStorefrontIcon(node) {
      if (!node || !node.handle) return null;
      const fields = {};
      (node.fields || []).forEach((field) => {
        fields[field.key] = field;
      });
      const get = (key) => (fields[key] ? fields[key].value : null);
      const getRefHandle = (key) =>
        fields[key] && fields[key].reference ? fields[key].reference.handle : null;

      const active = get('active');
      return {
        handle: node.handle,
        name: get('name') || node.handle,
        friendlyName: get('friendly_name') || get('name') || node.handle,
        category: getRefHandle('category') || '',
        sortOrder: parseFloat(get('sort_order')) || 0,
        active: active === null ? true : active !== 'false',
        svg: get('svg') || '',
      };
    }

    ensureIconTemplate(icon) {
      if (!icon || !icon.svg) return;
      if (this.querySelector('[data-icon-handle="' + icon.handle + '"]')) return;
      const tpl = document.createElement('template');
      tpl.setAttribute('data-icon-handle', icon.handle);
      tpl.innerHTML = icon.svg;
      this.appendChild(tpl);
    }

    cloneIconTemplate(handle) {
      const tpl = this.querySelector('[data-icon-handle="' + handle + '"]');
      if (!tpl) {
        console.warn('PlateCustomizer: template not found for icon handle', handle);
        return null;
      }
      const wrap = document.createElement('span');
      if (tpl.content && tpl.content.childNodes && tpl.content.childNodes.length > 0) {
        wrap.appendChild(tpl.content.cloneNode(true));
      } else {
        const raw = (tpl.innerHTML || '').trim();
        if (!raw) {
          console.warn('PlateCustomizer: empty SVG template for icon handle', handle);
          return null;
        }
        wrap.innerHTML = raw;
      }
      if (!wrap.querySelector('svg')) {
        console.warn('PlateCustomizer: SVG element not found inside template for handle', handle);
        return null;
      }
      this.normalizeIconSvg(wrap, handle);
      return wrap;
    }

    normalizeIconSvg(wrap, handle) {
      this.restoreSvgPresentationAttrs(wrap);
      this.stripIconCanvasBackground(wrap.querySelector('svg'));
      this.scopeIconStyles(wrap, handle);
      this.uniqueifySvgIds(wrap, handle);
    }

    parseSvgViewBox(svg) {
      const raw = svg && svg.getAttribute('viewBox');
      if (raw) {
        const parts = raw.trim().split(/[\s,]+/).map(Number);
        if (parts.length === 4 && parts.every(Number.isFinite) && parts[2] > 0 && parts[3] > 0) {
          return { x: parts[0], y: parts[1], width: parts[2], height: parts[3] };
        }
      }
      const width = parseFloat(svg && svg.getAttribute('width'));
      const height = parseFloat(svg && svg.getAttribute('height'));
      if (width > 0 && height > 0) return { x: 0, y: 0, width, height };
      return { x: 0, y: 0, width: 24, height: 24 };
    }

    collectCssFillMap(svg) {
      const map = {};
      if (!svg) return map;
      svg.querySelectorAll('style').forEach((style) => {
        const css = style.textContent || '';
        const ruleRe = /\.([a-zA-Z_][\w-]*)\s*\{([^}]+)\}/g;
        let match;
        while ((match = ruleRe.exec(css))) {
          const fillMatch = /(?:^|;)\s*fill\s*:\s*([^;]+)/i.exec(match[2]);
          if (fillMatch) map[match[1]] = fillMatch[1].trim();
        }
      });
      return map;
    }

    readElementFill(el, classFillMap) {
      if (!el || !el.getAttribute) return '';
      const style = el.getAttribute('style') || '';
      const styleFill = /(?:^|;)\s*fill\s*:\s*([^;]+)/i.exec(style);
      if (styleFill) return styleFill[1].trim();
      if (el.hasAttribute('fill')) return (el.getAttribute('fill') || '').trim();
      const classes = (el.getAttribute('class') || '').split(/\s+/);
      for (let i = 0; i < classes.length; i += 1) {
        const name = classes[i];
        if (name && classFillMap[name]) return classFillMap[name];
      }
      return '';
    }

    readEffectiveFill(el, classFillMap, root) {
      let node = el;
      while (node && node.nodeType === 1) {
        const fill = this.readElementFill(node, classFillMap);
        if (fill && fill.toLowerCase() !== 'inherit') return fill;
        if (node === root) break;
        node = node.parentNode;
      }
      return '';
    }

    isPaperFill(value) {
      if (!value) return false;
      const raw = String(value).trim().toLowerCase().replace(/\s*!important\s*$/i, '');
      if (!raw || raw === 'none' || raw === 'transparent' || raw === 'currentcolor') return false;
      if (raw === 'white' || raw === 'canvas') return true;
      const rgb = raw.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/);
      if (rgb) {
        return Number(rgb[1]) >= 245 && Number(rgb[2]) >= 245 && Number(rgb[3]) >= 245;
      }
      let hex = raw.charAt(0) === '#' ? raw.slice(1) : '';
      if (/^[0-9a-f]{3}$/i.test(hex)) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (/^[0-9a-f]{6}$/i.test(hex)) {
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return r >= 245 && g >= 245 && b >= 245;
      }
      return false;
    }

    coversViewBox(box, viewBox, ratio) {
      return this.viewBoxCoverage(box, viewBox) >= ratio;
    }

    viewBoxCoverage(box, viewBox) {
      if (!box || !viewBox || viewBox.width <= 0 || viewBox.height <= 0) return 0;
      if (box.percent) return 1;
      if (!(box.width > 0) || !(box.height > 0)) return 0;
      const left = Math.max(box.x, viewBox.x);
      const top = Math.max(box.y, viewBox.y);
      const right = Math.min(box.x + box.width, viewBox.x + viewBox.width);
      const bottom = Math.min(box.y + box.height, viewBox.y + viewBox.height);
      const inter = Math.max(0, right - left) * Math.max(0, bottom - top);
      return inter / (viewBox.width * viewBox.height);
    }

    hasVisibleStroke(el) {
      if (!el) return false;
      const style = el.getAttribute('style') || '';
      const styleStroke = /(?:^|;)\s*stroke\s*:\s*([^;]+)/i.exec(style);
      const stroke = styleStroke ? styleStroke[1].trim() : (el.getAttribute('stroke') || '').trim();
      const value = String(stroke || '').trim().toLowerCase();
      if (!value || value === 'none' || value === 'transparent') return false;
      const styleWidth = /(?:^|;)\s*stroke-width\s*:\s*([^;]+)/i.exec(style);
      const width = parseFloat(styleWidth ? styleWidth[1] : el.getAttribute('stroke-width') || '1');
      return !(width === 0);
    }

    firstPaintedIconShape(svg) {
      const skip = {
        defs: true,
        style: true,
        title: true,
        desc: true,
        metadata: true,
        clippath: true,
        mask: true,
        lineargradient: true,
        radialgradient: true,
        filter: true,
        symbol: true,
        marker: true,
      };
      const walk = (node) => {
        const children = node.children ? Array.from(node.children) : [];
        for (let i = 0; i < children.length; i += 1) {
          const child = children[i];
          const tag = (child.tagName || '').toLowerCase();
          if (tag === 'g' || tag === 'svg' || tag === 'a') {
            const nested = walk(child);
            if (nested) return nested;
            continue;
          }
          if (skip[tag]) continue;
          return child;
        }
        return null;
      };
      return walk(svg);
    }

    readRectBox(el) {
      if (!el) return null;
      const tag = (el.tagName || '').toLowerCase();
      if (tag === 'rect') {
        const widthAttr = el.getAttribute('width');
        const heightAttr = el.getAttribute('height');
        const width = widthAttr && String(widthAttr).indexOf('%') !== -1 ? null : parseFloat(widthAttr);
        const height = heightAttr && String(heightAttr).indexOf('%') !== -1 ? null : parseFloat(heightAttr);
        if (widthAttr && String(widthAttr).indexOf('%') !== -1 && parseFloat(widthAttr) >= 90) {
          return { x: parseFloat(el.getAttribute('x')) || 0, y: parseFloat(el.getAttribute('y')) || 0, width: -1, height: -1, percent: true };
        }
        if (!(width > 0) || !(height > 0)) return null;
        return {
          x: parseFloat(el.getAttribute('x')) || 0,
          y: parseFloat(el.getAttribute('y')) || 0,
          width,
          height,
        };
      }
      if (tag === 'path') return this.readRectPathBox(el.getAttribute('d'));
      if (tag === 'polygon') {
        const points = (el.getAttribute('points') || '')
          .trim()
          .split(/[\s,]+/)
          .map(Number)
          .filter(Number.isFinite);
        if (points.length < 8 || points.length % 2 !== 0) return null;
        const xs = [];
        const ys = [];
        for (let i = 0; i < points.length; i += 2) {
          xs.push(points[i]);
          ys.push(points[i + 1]);
        }
        return {
          x: Math.min.apply(null, xs),
          y: Math.min.apply(null, ys),
          width: Math.max.apply(null, xs) - Math.min.apply(null, xs),
          height: Math.max.apply(null, ys) - Math.min.apply(null, ys),
        };
      }
      return null;
    }

    readRectPathBox(d) {
      const source = String(d || '').replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
      if (!source) return null;
      let match = source.match(
        /^M\s*(-?[\d.]+)\s+(-?[\d.]+)\s*H\s*(-?[\d.]+)\s*V\s*(-?[\d.]+)\s*H\s*(-?[\d.]+)(?:\s*V\s*(-?[\d.]+))?\s*Z$/i
      );
      if (match) {
        const x = parseFloat(match[1]);
        const y = parseFloat(match[2]);
        const x2 = parseFloat(match[3]);
        const y2 = parseFloat(match[4]);
        return {
          x: Math.min(x, x2),
          y: Math.min(y, y2),
          width: Math.abs(x2 - x),
          height: Math.abs(y2 - y),
        };
      }
      match = source.match(
        /^M\s*(-?[\d.]+)\s+(-?[\d.]+)\s*h\s*(-?[\d.]+)\s*v\s*(-?[\d.]+)\s*h\s*(-?[\d.]+)(?:\s*v\s*(-?[\d.]+))?\s*z$/i
      );
      if (match) {
        const x = parseFloat(match[1]);
        const y = parseFloat(match[2]);
        const w = parseFloat(match[3]);
        const h = parseFloat(match[4]);
        return { x: Math.min(x, x + w), y: Math.min(y, y + h), width: Math.abs(w), height: Math.abs(h) };
      }
      match = source.match(
        /^M\s*(-?[\d.]+)\s+(-?[\d.]+)\s*L\s*(-?[\d.]+)\s+(-?[\d.]+)\s*L\s*(-?[\d.]+)\s+(-?[\d.]+)\s*L\s*(-?[\d.]+)\s+(-?[\d.]+)\s*Z$/i
      );
      if (match) {
        const xs = [match[1], match[3], match[5], match[7]].map(parseFloat);
        const ys = [match[2], match[4], match[6], match[8]].map(parseFloat);
        return {
          x: Math.min.apply(null, xs),
          y: Math.min.apply(null, ys),
          width: Math.max.apply(null, xs) - Math.min.apply(null, xs),
          height: Math.max.apply(null, ys) - Math.min.apply(null, ys),
        };
      }
      return null;
    }

    stripIconCanvasBackground(svg) {
      if (!svg) return;
      const cleanStyle = (value) =>
        String(value || '')
          .replace(/(?:^|;)\s*background(?:-color)?\s*:[^;]*/gi, '')
          .replace(/^;+|;+$/g, '')
          .trim();

      if (svg.hasAttribute('style')) {
        const next = cleanStyle(svg.getAttribute('style'));
        if (next) svg.setAttribute('style', next);
        else svg.removeAttribute('style');
      }

      svg.querySelectorAll('style').forEach((style) => {
        style.textContent = String(style.textContent || '')
          .replace(/background-color\s*:\s*[^;]+;?/gi, '')
          .replace(/background\s*:\s*[^;]+;?/gi, '');
      });

      const viewBox = this.parseSvgViewBox(svg);
      const classFillMap = this.collectCssFillMap(svg);
      const firstPainted = this.firstPaintedIconShape(svg);
      const candidates = svg.querySelectorAll('rect, path, polygon');
      candidates.forEach((el) => {
        const fill = this.readEffectiveFill(el, classFillMap, svg);
        if (!this.isPaperFill(fill)) return;
        if (this.hasVisibleStroke(el)) return;
        const box = this.readRectBox(el);
        if (!box) return;
        const coverage = this.viewBoxCoverage(box, viewBox);
        const isFirst = el === firstPainted;
        if (coverage >= 0.82 || (isFirst && coverage >= 0.45)) {
          if (el.parentNode) el.parentNode.removeChild(el);
        }
      });
    }

    restoreSvgPresentationAttrs(root) {
      const aliases = {
        fillrule: 'fill-rule',
        cliprule: 'clip-rule',
        clippath: 'clip-path',
        strokewidth: 'stroke-width',
        strokelinejoin: 'stroke-linejoin',
        strokelinecap: 'stroke-linecap',
        fillopacity: 'fill-opacity',
        strokeopacity: 'stroke-opacity',
        stopcolor: 'stop-color',
        stopopacity: 'stop-opacity',
        fontfamily: 'font-family',
        fontsize: 'font-size',
        fontweight: 'font-weight',
        textanchor: 'text-anchor',
        colorinterpolation: 'color-interpolation',
      };
      const nodes = [];
      if (root.getAttribute) nodes.push(root);
      if (root.querySelectorAll) {
        root.querySelectorAll('*').forEach((el) => nodes.push(el));
      }
      nodes.forEach((el) => {
        if (!el.getAttribute) return;
        Object.keys(aliases).forEach((from) => {
          if (el.hasAttribute(from) && !el.hasAttribute(aliases[from])) {
            el.setAttribute(aliases[from], el.getAttribute(from));
          }
        });
      });
    }

    uniqueifySvgIds(root, handle) {
      this._iconUid += 1;
      const safeHandle = String(handle || 'icon').replace(/[^a-zA-Z0-9_-]/g, '_');
      const prefix = 'picto_' + safeHandle + '_' + this._iconUid + '_';
      const idMap = {};

      root.querySelectorAll('[id]').forEach((el) => {
        const oldId = el.getAttribute('id');
        if (!oldId) return;
        const next = prefix + oldId;
        idMap[oldId] = next;
        el.setAttribute('id', next);
      });

      const oldIds = Object.keys(idMap).sort((a, b) => b.length - a.length);
      if (oldIds.length === 0) return;

      const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const rewriteValue = (value) => {
        if (!value) return value;
        let next = value;
        oldIds.forEach((oldId) => {
          const escaped = escapeRegex(oldId);
          next = next.replace(
            new RegExp('url\\(\\s*[\'"]?#' + escaped + '[\'"]?\\s*\\)', 'g'),
            'url(#' + idMap[oldId] + ')'
          );
          next = next.replace(new RegExp('(^|[\\s"\'(,])#' + escaped + '(?=[\\s"\')]|$)', 'g'), '$1#' + idMap[oldId]);
        });
        return next;
      };

      const refAttrs = [
        'href',
        'xlink:href',
        'clip-path',
        'mask',
        'fill',
        'stroke',
        'filter',
        'marker-start',
        'marker-mid',
        'marker-end',
      ];
      const XLINK_NS = 'http://www.w3.org/1999/xlink';

      root.querySelectorAll('*').forEach((el) => {
        refAttrs.forEach((attr) => {
          if (!el.hasAttribute(attr)) return;
          el.setAttribute(attr, rewriteValue(el.getAttribute(attr)));
        });
        if (el.hasAttribute('style')) {
          el.setAttribute('style', rewriteValue(el.getAttribute('style')));
        }
        try {
          const xlinkHref = el.getAttributeNS(XLINK_NS, 'href');
          if (xlinkHref) {
            el.setAttributeNS(XLINK_NS, 'href', rewriteValue(xlinkHref));
          }
        } catch (err) {
          /* ignore */
        }
      });

      root.querySelectorAll('style').forEach((style) => {
        style.textContent = rewriteValue(style.textContent || '');
      });
    }

    scopeCssRules(css, scopeSelector) {
      const prefixBlock = (block) => {
        const idx = block.indexOf('{');
        if (idx === -1) return block;
        const selectors = block.slice(0, idx);
        const body = block.slice(idx);
        const trimmed = selectors.trim();
        if (!trimmed) return block;
        if (trimmed.charAt(0) === '@') {
          if (/^@(media|supports|layer)\b/i.test(trimmed)) {
            return trimmed + '{' + this.scopeCssRules(body.slice(1), scopeSelector);
          }
          return block;
        }
        const scoped = trimmed
          .split(',')
          .map((sel) => {
            const s = sel.trim();
            if (!s) return s;
            if (s.indexOf(scopeSelector) === 0) return s;
            return scopeSelector + ' ' + s;
          })
          .join(', ');
        return scoped + body;
      };

      const parts = css.split('}');
      return parts
        .map((part, index) => {
          if (index === parts.length - 1 && !part.trim()) return '';
          if (part.indexOf('{') === -1) return part;
          return prefixBlock(part) + '}';
        })
        .join('');
    }

    scopeIconStyles(wrap, handle) {
      const styles = wrap.querySelectorAll('style');
      const svg = wrap.querySelector('svg');
      const safeHandle = String(handle || '').replace(/[^a-zA-Z0-9_-]/g, '_');
      const scopeClass = '__picto_' + safeHandle + '__root';
      const prefix = '__picto_' + safeHandle + '__';

      if (svg) {
        const existing = svg.getAttribute('class') || '';
        if (existing.split(/\s+/).indexOf(scopeClass) === -1) {
          svg.setAttribute('class', (existing + ' ' + scopeClass).trim());
        }
      }

      if (!styles || styles.length === 0) return;

      const classNames = new Set();
      styles.forEach((style) => {
        const text = style.textContent || '';
        const matches = text.match(/\.[a-zA-Z_][\w-]*/g);
        if (matches) {
          matches.forEach((m) => classNames.add(m.slice(1)));
        }
      });

      const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      if (classNames.size > 0) {
        styles.forEach((style) => {
          let css = style.textContent || '';
          classNames.forEach((cls) => {
            const re = new RegExp('\\.' + escapeRegex(cls) + '(?![\\w-])', 'g');
            css = css.replace(re, '.' + prefix + cls);
          });
          style.textContent = css;
        });

        wrap.querySelectorAll('[class]').forEach((el) => {
          const classAttr = el.getAttribute('class');
          if (!classAttr) return;
          const parts = classAttr.split(/\s+/);
          let changed = false;
          const next = parts
            .map((c) => {
              if (classNames.has(c)) {
                changed = true;
                return prefix + c;
              }
              return c;
            })
            .join(' ');
          if (changed) el.setAttribute('class', next);
        });
      }

      styles.forEach((style) => {
        style.textContent = this.scopeCssRules(style.textContent || '', '.' + scopeClass);
      });
    }

    copySvgRootAttrs(from, to) {
      if (!from || !to || !from.attributes) return;
      const skip = {
        width: true,
        height: true,
        x: true,
        y: true,
        viewbox: true,
        xmlns: true,
        preserveaspectratio: true,
        overflow: true,
      };
      Array.from(from.attributes).forEach((attr) => {
        const name = attr.name;
        if (skip[name.toLowerCase()]) return;
        if (!to.hasAttribute(name)) to.setAttribute(name, attr.value);
      });
    }

    lockSvgPaints(root) {
      if (!root) return;
      const attrs = ['fill', 'stroke', 'fill-rule', 'clip-rule', 'fill-opacity', 'stroke-width', 'stroke-opacity'];
      const nodes = [root];
      if (root.querySelectorAll) {
        root.querySelectorAll('*').forEach((el) => nodes.push(el));
      }
      nodes.forEach((el) => {
        if (!el.getAttribute || !el.style || !el.style.setProperty) return;
        attrs.forEach((attr) => {
          if (!el.hasAttribute(attr)) return;
          const value = el.getAttribute(attr);
          if (!value) return;
          el.style.setProperty(attr, value);
        });
      });
    }

    embedIconSvg(iconHost, iconRoot, iconX, iconY, iconSize) {
      const SVG_NS = 'http://www.w3.org/2000/svg';
      const viewBox = iconRoot.getAttribute('viewBox') || '0 0 24 24';
      const wrapper = document.createElementNS(SVG_NS, 'svg');
      wrapper.setAttribute('viewBox', viewBox);
      wrapper.setAttribute('width', String(iconSize));
      wrapper.setAttribute('height', String(iconSize));
      wrapper.setAttribute('x', String(iconX));
      wrapper.setAttribute('y', String(iconY));
      wrapper.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      wrapper.setAttribute('overflow', 'visible');
      this.copySvgRootAttrs(iconRoot, wrapper);

      iconRoot.querySelectorAll('script').forEach((node) => {
        if (node.parentNode) node.parentNode.removeChild(node);
      });

      Array.from(iconHost.childNodes).forEach((node) => {
        if (node === iconRoot) {
          Array.from(iconRoot.childNodes).forEach((child) => {
            wrapper.appendChild(child.cloneNode(true));
          });
        } else if (node.nodeType === 1 && (node.tagName || '').toLowerCase() !== 'script') {
          wrapper.appendChild(node.cloneNode(true));
        }
      });

      this.lockSvgPaints(wrapper);
      return wrapper;
    }

    cacheElements() {
      this.form = this.querySelector('form');
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.propModelo = this.querySelector('[data-prop-modelo]');
      this.propTexto = this.querySelector('[data-prop-texto]');
      this.propIcones = this.querySelector('[data-prop-icones]');
      this.propHandles = this.querySelector('[data-prop-handles]');

      this.previewPlate = this.querySelector('[data-preview-plate]');
      this.previewRender = this.querySelector('[data-preview-render]');
      this.previewHeader = this.querySelector('[data-preview-header]');
      this.previewBadge = this.querySelector('[data-preview-badge]');
      this.previewTitle = this.querySelector('[data-preview-title]');
      this.previewBody = this.querySelector('[data-preview-body]');
      this.previewIcons = this.querySelector('[data-preview-icons]');
      this.previewText = this.querySelector('[data-preview-text]');
      this.previewFooter = this.querySelector('[data-preview-footer]');
      this.previewFooterText = this.querySelector('[data-preview-footer-text]');
      this.previewBack = this.querySelector('[data-preview-back]');
      this.previewSvgEl = this.querySelector('[data-preview-svg]');
      this.previewCotaW = this.querySelector('[data-preview-cota-width]');
      this.previewCotaH = this.querySelector('[data-preview-cota-height]');

      this.textInput = this.querySelector('[data-input-texto-display]');
      this.textCounter = this.querySelector('[data-text-counter]');
      this.textWarning = this.querySelector('[data-text-warning]');
      this.textCounterTemplate = this.textCounter ? this.textCounter.dataset.counterTemplate || '__count__ / __max__' : '__count__ / __max__';
      this.reviewTrigger = this.querySelector('[data-review-trigger]');
      this.reviewTriggerLabel = this.querySelector('[data-review-trigger-label]');
      this.reviewPanel = this.querySelector('[data-review-panel]');
      this.reviewViews = {};
      this.querySelectorAll('[data-review-view]').forEach((el) => {
        this.reviewViews[el.dataset.reviewView] = el;
      });
      this.reviewOriginalEl = this.querySelector('[data-review-original]');
      this.reviewRevisedEl = this.querySelector('[data-review-revised]');
      this.reviewNotesEl = this.querySelector('[data-review-notes]');
      this.reviewHint = this.querySelector('[data-review-hint]');
      this.categoryInput = this.querySelector('[data-input-categoria]');
      this.modelsCarousel = this.querySelector('[data-models-carousel]');
      this.modelsTrack = this.querySelector('[data-models-track]');
      this.modelsPrevBtn = this.querySelector('[data-models-prev]');
      this.modelsNextBtn = this.querySelector('[data-models-next]');
      this.iconsScroll = this.querySelector('[data-icons-scroll]');
      this.iconsGrid = this.querySelector('[data-icons-grid]');
      this.iconsEmpty = this.querySelector('[data-icons-empty]');
      this.iconsSelected = this.querySelector('[data-icons-selected]');
      this.iconsSelectedGrid = this.querySelector('[data-icons-selected-grid]');

      this.buttonBack = this.querySelector('[data-action-back]');
      this.backRow = this.querySelector('[data-back-row]');
      this.buttonContinue = this.querySelector('[data-action-continue]');
      this.buttonBuy = this.querySelector('[data-action-buy]');
      this.priceWrapper = this.querySelector('[data-price]');
      this.priceCurrentValue = this.querySelector('[data-price-value]');
      this.priceCompare = this.querySelector('[data-price-compare]');
      this.priceCompareValue = this.querySelector('[data-price-compare-value]');

      this.errorMessage = this.querySelector('[data-error-message]');
      this.errorWrapper = this.errorMessage ? this.errorMessage.parentElement : null;

      this.wallBtn = this.querySelector('[data-wall-open]');
      this.wallModal = this.querySelector('[data-wall-modal]');
      this.wallStage = this.querySelector('[data-wall-stage]');
      this.wallImage = this.querySelector('[data-wall-image]');
      this.wallPlateSlot = this.querySelector('[data-wall-plate-slot]');
      this.wallRealWidthCm = parseFloat(this.dataset.wallRealWidthCm) || 300;
      this.wallPlateX = parseFloat(this.dataset.wallPlateX) || 60;
      this.wallPlateY = parseFloat(this.dataset.wallPlateY) || 40;

      this.quantityWrapper = this.querySelector('[data-quantity-wrapper]');
      this.quantityInput = this.querySelector('.quantity__input');
      this.quantityDecreaseBtn = this.querySelector('[data-quantity-decrease]');
      this.quantityIncreaseBtn = this.querySelector('[data-quantity-increase]');
      this.discountsWrapper = this.querySelector('[data-quantity-discounts-wrapper]');
    }

    setupModelsCarousel() {
      if (!this.modelsCarousel || !this.modelsTrack) return;

      const scrollByPage = (direction) => {
        const amount = Math.max(this.modelsTrack.clientWidth * 0.9, 1);
        this.modelsTrack.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      if (this.modelsPrevBtn) {
        this.modelsPrevBtn.addEventListener('click', () => scrollByPage(-1));
      }
      if (this.modelsNextBtn) {
        this.modelsNextBtn.addEventListener('click', () => scrollByPage(1));
      }

      this.modelsTrack.addEventListener('scroll', () => this.updateModelsCarousel(), { passive: true });
      window.addEventListener('resize', () => this.updateModelsCarousel());

      this.updateModelsCarousel();
      requestAnimationFrame(() => this.updateModelsCarousel());
    }

    updateModelsCarousel() {
      if (!this.modelsTrack) return;
      const maxScroll = this.modelsTrack.scrollWidth - this.modelsTrack.clientWidth;
      const hasOverflow = maxScroll > 1;
      const scrollLeft = this.modelsTrack.scrollLeft;

      if (this.modelsPrevBtn) {
        this.modelsPrevBtn.hidden = !hasOverflow;
        this.modelsPrevBtn.disabled = scrollLeft <= 1;
      }
      if (this.modelsNextBtn) {
        this.modelsNextBtn.hidden = !hasOverflow;
        this.modelsNextBtn.disabled = scrollLeft >= maxScroll - 1;
      }
    }

    setupModelImages() {
      this.querySelectorAll('.plate-card__model-img').forEach((img) => {
        img.addEventListener('error', () => this.showModelImageFallback(img), { once: true });
        // A imagem pode ter falhado antes do custom element ser definido.
        if (img.complete && img.naturalWidth === 0) this.showModelImageFallback(img);
      });
    }

    showModelImageFallback(img) {
      if (img.hidden) return;
      img.hidden = true;
      const media = img.closest('.plate-card__model-media');
      const fallback = media && media.querySelector('[data-model-fallback]');
      if (fallback) fallback.hidden = false;
      console.warn('[plate-customizer] model image failed to load', img.currentSrc || img.src);
    }

    showModelRequiredError() {
      if (this.currentStep !== 'design') this.goToStep('design');
      this.showError(this.dataset.errorModel);
      if (this.modelsCarousel) this.modelsCarousel.classList.add('has-error');
      const firstModel = this.querySelector('[data-input-model]');
      if (firstModel) firstModel.focus();
    }

    setupIconsScrollFade() {
      if (!this.iconsGrid || !this.iconsScroll) return;
      this.iconsGrid.addEventListener('scroll', () => this.updateIconsScrollFade(), { passive: true });
      window.addEventListener('resize', () => this.updateIconsScrollFade());
      this.updateIconsScrollFade();
    }

    updateIconsScrollFade() {
      if (!this.iconsGrid || !this.iconsScroll) return;
      const grid = this.iconsGrid;
      const maxScroll = grid.scrollHeight - grid.clientHeight;
      const canScroll = maxScroll > 1;
      this.iconsScroll.classList.toggle('can-scroll-up', canScroll && grid.scrollTop > 1);
      this.iconsScroll.classList.toggle('can-scroll-down', canScroll && grid.scrollTop < maxScroll - 1);
    }

    bindEvents() {
      this.querySelectorAll('[data-input-size]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.size = input.value;
          this.markChecked('[data-input-size]', input);
          this.updateOptionAvailability();
          this.refreshPreviewSize();
          this.refreshVariant();
        });
      });

      this.querySelectorAll('[data-input-material]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.material = input.value;
          this.markChecked('[data-input-material]', input);
          this.updateOptionAvailability();
          this.refreshPreview();
          this.refreshVariant();
        });
      });

      this.querySelectorAll('[data-input-fixacao]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.fixacao = input.value;
          this.markChecked('[data-input-fixacao]', input);
          this.updateOptionAvailability();
          this.refreshPreview();
          this.refreshVariant();
        });
      });

      this.querySelectorAll('[data-input-model]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.modelHandle = input.value;
          this.markChecked('[data-input-model]', input);
          if (this.modelsCarousel) this.modelsCarousel.classList.remove('has-error');
          if (this.propModelo) {
            const product = this.products[this.state.modelHandle];
            this.propModelo.value = product ? product.title : '';
          }
          this.updateOptionAvailability();
          this.renderIcons();
          this.refreshPreview();
          this.refreshVariant();
        });
      });

      this.querySelectorAll('[data-size-thumb]').forEach((thumb) => {
        const value = thumb.dataset.sizeThumb;
        const dims = this.parseSize(value);
        if (dims) {
          const maxDim = 5;
          const ratio = dims.w / dims.h;
          let w;
          let h;
          if (ratio >= 1) {
            w = maxDim;
            h = maxDim / ratio;
          } else {
            h = maxDim;
            w = maxDim * ratio;
          }
          thumb.style.setProperty('--thumb-w', w + 'rem');
          thumb.style.setProperty('--thumb-h', h + 'rem');
        }
      });

      if (this.textInput) {
        this.textInput.addEventListener('input', () => {
          const raw = this.textInput.value;
          const clean = stripPlateEmoji(raw);
          if (clean !== raw) {
            const caret = this.textInput.selectionStart - (raw.length - clean.length);
            this.textInput.value = clean;
            const pos = Math.max(0, Math.min(caret, clean.length));
            this.textInput.setSelectionRange(pos, pos);
            this.flagEmojiBlocked();
          }
          this.state.text = clean;
          this.updateCounter();
          this.refreshPreview();
          this.onTextEdited();
        });
      }

      if (this.reviewTrigger) {
        this.reviewTrigger.addEventListener('click', () => this.requestTextReview());
      }
      this.querySelectorAll('[data-review-accept]').forEach((button) => {
        button.addEventListener('click', () => this.applyReviewedText());
      });
      this.querySelectorAll('[data-review-keep]').forEach((button) => {
        button.addEventListener('click', () => this.keepOriginalText());
      });
      this.querySelectorAll('[data-review-retry]').forEach((button) => {
        button.addEventListener('click', () => this.requestTextReview());
      });
      this.querySelectorAll('[data-review-undo]').forEach((button) => {
        button.addEventListener('click', () => this.restoreOriginalText());
      });

      if (this.previewText) {
        this.previewText.addEventListener('input', () => this.onPreviewTextInput());
        this.previewText.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.previewText.blur();
          }
        });
        this.previewText.addEventListener('paste', (event) => this.onPreviewTextPaste(event));
        this.previewText.addEventListener('blur', () => this.refreshPreview());
      }

      if (this.previewSvgEl) {
        this.previewSvgEl.addEventListener('click', (event) => this.onSvgPreviewClick(event));
      }

      if (this.categoryInput) {
        this.categoryInput.addEventListener('change', () => {
          this.state.category = this.categoryInput.value;
          this.renderIcons();
        });
      }

      if (this.buttonContinue) {
        this.buttonContinue.addEventListener('click', () => this.goNext());
      }
      if (this.buttonBack) {
        this.buttonBack.addEventListener('click', () => this.goPrev());
      }

      this.querySelectorAll('[data-step-indicator]').forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = dot.dataset.stepIndicator;
          if (this.stepOrder.indexOf(target) < this.stepOrder.indexOf(this.currentStep)) {
            this.goToStep(target);
          }
        });
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }

      if (this.quantityDecreaseBtn) {
        this.quantityDecreaseBtn.addEventListener('click', () => this.stepQuantity(-1));
      }
      if (this.quantityIncreaseBtn) {
        this.quantityIncreaseBtn.addEventListener('click', () => this.stepQuantity(1));
      }
      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', () => this.refreshVariant());
        this.quantityInput.addEventListener('change', () => this.refreshVariant());
      }

      if (this.wallBtn) {
        this.wallBtn.addEventListener('click', () => this.openWallModal());
      }
      this.querySelectorAll('[data-wall-modal-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeWallModal());
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.wallModal && !this.wallModal.hidden) {
          this.closeWallModal();
        }
      });
      window.addEventListener('resize', () => {
        if (this.wallModal && !this.wallModal.hidden) this.layoutWallPlate();
      });
    }

    initState() {
      const sizeChecked = this.querySelector('[data-input-size]:checked');
      if (sizeChecked) this.state.size = sizeChecked.value;

      const materialChecked = this.querySelector('[data-input-material]:checked');
      if (materialChecked) this.state.material = materialChecked.value;

      const fixacaoChecked = this.querySelector('[data-input-fixacao]:checked');
      if (fixacaoChecked) this.state.fixacao = fixacaoChecked.value;

      this.refreshPreviewSize();
      this.updateCounter();
      this.syncPreviewEditable();
    }

    updateCounter() {
      if (!this.textCounter) return;
      this.textCounter.textContent = this.textCounterTemplate
        .replaceAll('__count__', String(this.state.text.length))
        .replaceAll('__max__', String(this.maxText));
    }

    flagEmojiBlocked() {
      if (!this.textWarning) return;
      this.textWarning.hidden = false;
      if (this._emojiWarningTimer) clearTimeout(this._emojiWarningTimer);
      this._emojiWarningTimer = setTimeout(() => {
        this.textWarning.hidden = true;
        this._emojiWarningTimer = null;
      }, 4000);
    }

    syncPreviewEditable() {
      const editable = this.currentStep === 'design';
      if (this.previewText) {
        if (editable) {
          this.previewText.setAttribute('contenteditable', 'plaintext-only');
          this.previewText.setAttribute('role', 'textbox');
          this.previewText.setAttribute('aria-multiline', 'true');
          this.previewText.setAttribute('spellcheck', 'false');
        } else {
          this.previewText.removeAttribute('contenteditable');
          this.previewText.removeAttribute('role');
          this.previewText.removeAttribute('aria-multiline');
          this.previewText.removeAttribute('spellcheck');
        }
      }
      if (this.previewSvgEl) {
        this.previewSvgEl.classList.toggle('is-editable', editable);
        if (!editable) this.exitSvgTextEdit();
      }
    }

    onPreviewTextInput() {
      if (!this.previewText) return;
      let value = this.previewText.textContent || '';
      const stripped = stripPlateEmoji(value);
      if (stripped !== value) {
        value = stripped;
        this.previewText.textContent = value.toUpperCase();
        this.placeCaretAtEnd(this.previewText);
        this.flagEmojiBlocked();
      }
      if (this.maxText && value.length > this.maxText) {
        value = value.slice(0, this.maxText);
        this.previewText.textContent = value.toUpperCase();
        this.placeCaretAtEnd(this.previewText);
      }
      this.state.text = value;
      if (this.textInput) this.textInput.value = value;
      this.updateCounter();
      this.updateBodyLayout();
      this.onTextEdited();
    }

    onPreviewTextPaste(event) {
      event.preventDefault();
      const text = (event.clipboardData || window.clipboardData).getData('text');
      const normalized = String(text || '').replace(/\r?\n/g, ' ');
      const sanitized = stripPlateEmoji(normalized);
      if (sanitized !== normalized) this.flagEmojiBlocked();
      document.execCommand('insertText', false, sanitized);
    }

    onSvgPreviewClick(event) {
      if (this.currentStep !== 'design') return;
      if (!this.previewSvgEl) return;
      const target = event.target && event.target.closest
        ? event.target.closest('[data-plate-text-render]')
        : null;
      if (!target) return;
      this.enterSvgTextEdit(target);
    }

    exitSvgTextEdit() {
      if (!this.previewSvgEl) return;
      const existing = this.previewSvgEl.querySelector('[data-plate-text-edit]');
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
      this._svgTextEditing = false;
    }

    enterSvgTextEdit(textEl) {
      if (!this.previewSvgEl || !textEl) return;
      const svg = this.previewSvgEl.querySelector('svg');
      if (!svg) return;
      if (this._svgTextEditing) return;

      const x = parseFloat(textEl.getAttribute('data-box-x'));
      const y = parseFloat(textEl.getAttribute('data-box-y'));
      const w = parseFloat(textEl.getAttribute('data-box-width'));
      const h = parseFloat(textEl.getAttribute('data-box-height'));
      if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        if (this.textInput) this.textInput.focus();
        return;
      }

      const fontSize = parseFloat(textEl.getAttribute('font-size')) || 16;
      const fontFamily = textEl.getAttribute('font-family')
        || "'Helvetica LT Condensed Black', Helvetica, Arial, sans-serif";
      const fontWeight = textEl.getAttribute('font-weight') || '900';
      const fillColor = textEl.getAttribute('fill') || '#111827';
      const align = (textEl.getAttribute('data-box-align') || 'middle').toLowerCase();
      const verticalAlign = (textEl.getAttribute('data-box-vertical-align') || 'middle').toLowerCase();
      const lineHeight = parseFloat(textEl.getAttribute('data-box-line-height')) || 1.1;

      const justify = verticalAlign === 'top' || verticalAlign === 'start' || verticalAlign === 'hanging'
        ? 'flex-start'
        : (verticalAlign === 'bottom' || verticalAlign === 'end' ? 'flex-end' : 'center');
      const alignItems = align === 'start' || align === 'left'
        ? 'flex-start'
        : (align === 'end' || align === 'right' ? 'flex-end' : 'center');
      const textAlign = align === 'start' || align === 'left'
        ? 'left'
        : (align === 'end' || align === 'right' ? 'right' : 'center');

      const SVG_NS = 'http://www.w3.org/2000/svg';
      const XHTML_NS = 'http://www.w3.org/1999/xhtml';
      const fo = document.createElementNS(SVG_NS, 'foreignObject');
      fo.setAttribute('data-plate-text-edit', '');
      fo.setAttribute('x', String(x));
      fo.setAttribute('y', String(y));
      fo.setAttribute('width', String(w));
      fo.setAttribute('height', String(h));

      const editor = document.createElementNS(XHTML_NS, 'div');
      editor.setAttribute('contenteditable', 'plaintext-only');
      editor.setAttribute('spellcheck', 'false');
      editor.setAttribute('data-plate-text-editor', '');
      editor.style.cssText = [
        'box-sizing:border-box',
        'width:100%',
        'height:100%',
        'display:flex',
        'flex-direction:column',
        'justify-content:' + justify,
        'align-items:' + alignItems,
        'text-align:' + textAlign,
        'font-family:' + fontFamily,
        'font-weight:' + fontWeight,
        'font-size:' + fontSize + 'px',
        'line-height:' + lineHeight,
        'color:' + fillColor,
        'letter-spacing:0',
        'outline:0.08em dashed rgba(17, 24, 39, 0.4)',
        'outline-offset:0.04em',
        'cursor:text',
        'overflow:hidden',
        'white-space:pre-wrap',
        'word-break:break-word',
        'overflow-wrap:anywhere',
        'text-transform:uppercase',
        'background:transparent',
      ].join(';');
      editor.textContent = (this.state.text || '').toUpperCase();

      fo.appendChild(editor);
      svg.appendChild(fo);
      this._svgTextEditing = true;
      textEl.style.visibility = 'hidden';

      editor.focus();
      this.placeCaretAtEnd(editor);

      const handleInput = () => {
        let value = editor.textContent || '';
        const stripped = stripPlateEmoji(value);
        if (stripped !== value) {
          value = stripped;
          editor.textContent = value.toUpperCase();
          this.placeCaretAtEnd(editor);
          this.flagEmojiBlocked();
        }
        if (this.maxText && value.length > this.maxText) {
          value = value.slice(0, this.maxText);
          editor.textContent = value.toUpperCase();
          this.placeCaretAtEnd(editor);
        }
        this.state.text = value;
        if (this.textInput) this.textInput.value = value;
        if (this.previewText && document.activeElement !== this.previewText) {
          this.previewText.textContent = value.toUpperCase();
        }
        this.updateCounter();
        this.onTextEdited();
      };

      const handlePaste = (event) => {
        event.preventDefault();
        const data = (event.clipboardData || window.clipboardData).getData('text');
        const normalized = String(data || '').replace(/\r?\n/g, ' ');
        const sanitized = stripPlateEmoji(normalized);
        if (sanitized !== normalized) this.flagEmojiBlocked();
        document.execCommand('insertText', false, sanitized);
      };

      const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          editor.blur();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          editor.blur();
        }
      };

      const handleBlur = () => {
        editor.removeEventListener('input', handleInput);
        editor.removeEventListener('paste', handlePaste);
        editor.removeEventListener('keydown', handleKeyDown);
        editor.removeEventListener('blur', handleBlur);
        this._svgTextEditing = false;
        this.refreshPreview();
      };

      editor.addEventListener('input', handleInput);
      editor.addEventListener('paste', handlePaste);
      editor.addEventListener('keydown', handleKeyDown);
      editor.addEventListener('blur', handleBlur);
    }

    placeCaretAtEnd(el) {
      if (!el) return;
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const selection = window.getSelection();
      if (!selection) return;
      selection.removeAllRanges();
      selection.addRange(range);
    }

    updateBodyLayout() {
      if (!this.previewBody) return;
      const count = this.state.selectedIcons.length;
      this.previewBody.classList.toggle('is-icons-1', count === 1);
      this.previewBody.classList.toggle('is-icons-2', count === 2);
      this.previewBody.classList.toggle('is-icons-3plus', count >= 3);
    }

    markChecked(selector, input) {
      this.querySelectorAll(selector).forEach((el) => {
        const label = el.closest('.plate-card, .plate-tab, .plate-icon-tile');
        if (label) label.classList.toggle('is-checked', el === input);
      });
    }

    parseSize(value) {
      if (!value) return null;
      const match = value.match(/(\d+)\s*[xX×]\s*(\d+)/);
      if (!match) return null;
      return { w: parseInt(match[1], 10), h: parseInt(match[2], 10) };
    }

    refreshPreviewSize() {
      const dims = this.parseSize(this.state.size);
      if (!dims || !this.previewPlate) return;
      this.previewPlate.style.setProperty('--plate-ratio', dims.w / dims.h);
      if (this.previewCotaW) this.previewCotaW.textContent = dims.w + ' cm';
      if (this.previewCotaH) this.previewCotaH.textContent = dims.h + ' cm';
    }

    escapeXml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
    }

    measureTextWidth(text, fontSize, fontFamily, fontWeight) {
      if (!this._measureCanvas) this._measureCanvas = document.createElement('canvas');
      const ctx = this._measureCanvas.getContext('2d');
      if (!ctx) return text.length * fontSize * 0.5;
      const font = (fontWeight || '900') + ' ' + fontSize + 'px ' + (fontFamily || 'Helvetica, Arial, sans-serif');
      if (!this._measureCache) this._measureCache = new Map();
      const key = font + ' ' + text;
      const cached = this._measureCache.get(key);
      if (cached !== undefined) return cached;
      ctx.font = font;
      const width = ctx.measureText(text).width;
      if (this._measureCache.size > 4000) this._measureCache.clear();
      this._measureCache.set(key, width);
      return width;
    }

    // Quebra uma palavra maior que a caixa em pedaços que caibam na largura.
    // Sem isso, uma palavra longa (ex.: "AAAA...") vira uma linha unica que
    // vaza para fora dos limites da placa.
    splitLongWord(word, fontSize, fontFamily, fontWeight, maxWidth) {
      const chars = Array.from(String(word || ''));
      if (chars.length <= 1) return chars.length ? [chars[0]] : [];
      const chunks = [];
      let current = '';
      chars.forEach((char) => {
        const candidate = current + char;
        if (current && this.measureTextWidth(candidate, fontSize, fontFamily, fontWeight) > maxWidth) {
          chunks.push(current);
          current = char;
        } else {
          current = candidate;
        }
      });
      if (current) chunks.push(current);
      return chunks.length ? chunks : [String(word)];
    }

    wrapTextLines(text, fontSize, fontFamily, fontWeight, maxWidth) {
      const source = String(text || '');
      if (!source) return [''];
      if (maxWidth <= 0) return [source];
      const paragraphs = source.split(/\r?\n/);
      const lines = [];
      paragraphs.forEach((paragraph) => {
        const words = paragraph.split(/\s+/).filter(Boolean);
        if (words.length === 0) {
          lines.push('');
          return;
        }
        let current = '';
        words.forEach((word) => {
          if (this.measureTextWidth(word, fontSize, fontFamily, fontWeight) > maxWidth) {
            if (current) {
              lines.push(current);
              current = '';
            }
            const chunks = this.splitLongWord(word, fontSize, fontFamily, fontWeight, maxWidth);
            chunks.forEach((chunk, index) => {
              if (index === chunks.length - 1) current = chunk;
              else lines.push(chunk);
            });
            return;
          }
          const candidate = current ? current + ' ' + word : word;
          const width = this.measureTextWidth(candidate, fontSize, fontFamily, fontWeight);
          if (width <= maxWidth || !current) {
            current = candidate;
          } else {
            lines.push(current);
            current = word;
          }
        });
        if (current) lines.push(current);
      });
      return lines.length ? lines : [''];
    }

    fitTextToBox(text, box, options) {
      const opts = options || {};
      const fontFamily = opts.fontFamily || "'Helvetica LT Condensed Black', Helvetica, Arial, sans-serif";
      const fontWeight = opts.fontWeight || '900';
      const lineHeight = opts.lineHeight > 0 ? opts.lineHeight : 1.1;
      const maxFontSize = opts.maxFontSize > 0 ? opts.maxFontSize : Math.max(8, box.height * 0.9);
      const minFontSize = opts.minFontSize > 0 ? opts.minFontSize : 6;
      const source = String(text == null ? '' : text);

      let chosen = { fontSize: minFontSize, lines: [source], lineHeight };
      for (let size = Math.floor(maxFontSize); size >= Math.floor(minFontSize); size -= 1) {
        const lines = this.wrapTextLines(source, size, fontFamily, fontWeight, box.width);
        const widestLine = lines.reduce((acc, line) => {
          const w = this.measureTextWidth(line, size, fontFamily, fontWeight);
          return w > acc ? w : acc;
        }, 0);
        const totalHeight = lines.length * size * lineHeight;
        if (widestLine <= box.width && totalHeight <= box.height) {
          chosen = { fontSize: size, lines, lineHeight };
          break;
        }
        chosen = { fontSize: size, lines, lineHeight };
      }
      return chosen;
    }

    collapseTextMarkersIntoIcons(root) {
      const readNum = (el, attr, fallback) => {
        const raw = el.getAttribute(attr) || el.getAttribute('data-' + attr);
        const v = parseFloat(raw);
        return Number.isFinite(v) ? v : fallback;
      };
      const textMarkers = Array.from(root.querySelectorAll('[data-plate-text]'));
      textMarkers.forEach((textMarker) => {
        const parent = textMarker.parentNode;
        if (!parent) return;
        const iconMarker = parent.querySelector(':scope > [data-plate-icons]')
          || parent.querySelector('[data-plate-icons]');
        if (!iconMarker) {
          parent.removeChild(textMarker);
          return;
        }
        const tx = readNum(textMarker, 'x', 0);
        const ty = readNum(textMarker, 'y', 0);
        const tw = readNum(textMarker, 'width', 0);
        const th = readNum(textMarker, 'height', 0);
        const ix = readNum(iconMarker, 'x', 0);
        const iy = readNum(iconMarker, 'y', 0);
        const iw = readNum(iconMarker, 'width', 0);
        const ih = readNum(iconMarker, 'height', 0);
        if (tw > 0 && th > 0 && iw > 0 && ih > 0) {
          const newX = Math.min(tx, ix);
          const newY = Math.min(ty, iy);
          const newRight = Math.max(tx + tw, ix + iw);
          const newBottom = Math.max(ty + th, iy + ih);
          iconMarker.setAttribute('x', String(newX));
          iconMarker.setAttribute('y', String(newY));
          iconMarker.setAttribute('width', String(newRight - newX));
          iconMarker.setAttribute('height', String(newBottom - newY));
        }
        parent.removeChild(textMarker);
      });
    }

    expandTextMarkers(root, text) {
      const SVG_NS = 'http://www.w3.org/2000/svg';
      const markers = Array.from(root.querySelectorAll('[data-plate-text]'));
      markers.forEach((marker) => {
        if (!marker.parentNode) return;

        const readNumber = (attr, fallback) => {
          const raw = marker.getAttribute(attr) || marker.getAttribute('data-' + attr);
          const value = parseFloat(raw);
          return Number.isFinite(value) ? value : fallback;
        };

        const box = {
          x: readNumber('x', 0),
          y: readNumber('y', 0),
          width: readNumber('width', 0),
          height: readNumber('height', 0),
        };
        if (box.width <= 0 || box.height <= 0) return;

        const align = (marker.getAttribute('data-text-align') || 'middle').toLowerCase();
        const verticalAlign = (marker.getAttribute('data-text-vertical-align') || 'middle').toLowerCase();
        const color = marker.getAttribute('data-text-color') || '#111827';
        const fontFamily = marker.getAttribute('data-text-font-family')
          || "'Helvetica LT Condensed Black', Helvetica, Arial, sans-serif";
        const fontWeight = marker.getAttribute('data-text-font-weight') || '900';
        const maxFontSize = parseFloat(marker.getAttribute('data-text-max-font-size')) || Math.max(8, box.height * 0.9);
        const minFontSize = parseFloat(marker.getAttribute('data-text-min-font-size')) || 6;
        const lineHeight = parseFloat(marker.getAttribute('data-text-line-height')) || 1.1;

        const fit = this.fitTextToBox(text, box, {
          fontFamily, fontWeight, lineHeight, maxFontSize, minFontSize,
        });

        const totalHeight = fit.lines.length * fit.fontSize * fit.lineHeight;
        let firstBaselineY;
        if (verticalAlign === 'top' || verticalAlign === 'start' || verticalAlign === 'hanging') {
          firstBaselineY = box.y + fit.fontSize;
        } else if (verticalAlign === 'bottom' || verticalAlign === 'end') {
          firstBaselineY = box.y + box.height - totalHeight + fit.fontSize;
        } else {
          firstBaselineY = box.y + (box.height - totalHeight) / 2 + fit.fontSize;
        }

        let anchor = 'middle';
        let textX = box.x + box.width / 2;
        if (align === 'start' || align === 'left') {
          anchor = 'start';
          textX = box.x;
        } else if (align === 'end' || align === 'right') {
          anchor = 'end';
          textX = box.x + box.width;
        }

        const textEl = document.createElementNS(SVG_NS, 'text');
        textEl.setAttribute('data-plate-text-render', '');
        textEl.setAttribute('x', String(textX));
        textEl.setAttribute('y', String(firstBaselineY));
        textEl.setAttribute('text-anchor', anchor);
        textEl.setAttribute('font-family', fontFamily);
        textEl.setAttribute('font-weight', fontWeight);
        textEl.setAttribute('font-size', String(fit.fontSize));
        textEl.setAttribute('fill', color);
        textEl.setAttribute('data-box-x', String(box.x));
        textEl.setAttribute('data-box-y', String(box.y));
        textEl.setAttribute('data-box-width', String(box.width));
        textEl.setAttribute('data-box-height', String(box.height));
        textEl.setAttribute('data-box-align', align);
        textEl.setAttribute('data-box-vertical-align', verticalAlign);
        textEl.setAttribute('data-box-line-height', String(lineHeight));

        const dyStep = fit.fontSize * fit.lineHeight;
        fit.lines.forEach((line, index) => {
          const tspan = document.createElementNS(SVG_NS, 'tspan');
          tspan.setAttribute('x', String(textX));
          tspan.setAttribute('dy', index === 0 ? '0' : String(dyStep));
          tspan.textContent = line;
          textEl.appendChild(tspan);
        });

        marker.parentNode.replaceChild(textEl, marker);
      });
    }

    layoutMatchesCount(raw, count) {
      const value = (raw == null ? '' : String(raw)).trim();
      if (!value || value === '*') return true;
      return value.split(',').some((token) => {
        const t = token.trim();
        if (!t) return false;
        if (t === '*') return true;
        if (t.endsWith('+')) {
          const n = parseInt(t.slice(0, -1), 10);
          return Number.isFinite(n) && count >= n;
        }
        const n = parseInt(t, 10);
        return Number.isFinite(n) && count === n;
      });
    }

    applyPreviewSvgPlaceholders(svg, text, title, iconHandles) {
      const handles = Array.isArray(iconHandles) ? iconHandles : [];
      const count = handles.length;
      const textValue = String(text == null ? '' : text);

      const withTokens = String(svg || '')
        .replace(/\{\{\s*TEXT\s*\}\}/g, this.escapeXml(textValue))
        .replace(/\{\{\s*TITLE\s*\}\}/g, this.escapeXml(title));

      const hasLayouts = withTokens.includes('data-plate-layout');
      const hasIconsMarker = withTokens.includes('data-plate-icons');
      const hasTextMarker = withTokens.includes('data-plate-text');
      if (!hasLayouts && !hasIconsMarker && !hasTextMarker) return withTokens;

      try {
        const tmpHost = document.createElement('div');
        tmpHost.innerHTML = withTokens;
        const svgRoot = tmpHost.querySelector('svg');
        if (!svgRoot) return withTokens;

        if (hasLayouts) {
          const layoutNodes = Array.from(svgRoot.querySelectorAll('[data-plate-layout]'));
          layoutNodes.forEach((node) => {
            if (!node.parentNode) return;
            if (!this.layoutMatchesCount(node.getAttribute('data-plate-layout'), count)) {
              node.parentNode.removeChild(node);
            }
          });
        }

        const trimmedText = textValue.replace(/\s+/g, '');
        if (!trimmedText && svgRoot.querySelector('[data-plate-text]')) {
          this.collapseTextMarkersIntoIcons(svgRoot);
        }

        if (svgRoot.querySelector('[data-plate-text]')) {
          this.expandTextMarkers(svgRoot, textValue);
        }

        const marker = svgRoot.querySelector('[data-plate-icons]');
        if (marker) {
          const readNumber = (attr, fallback) => {
            const raw = marker.getAttribute(attr) || marker.getAttribute('data-' + attr);
            const value = parseFloat(raw);
            return Number.isFinite(value) ? value : fallback;
          };

          const slotX = readNumber('x', 0);
          const slotY = readNumber('y', 0);
          const slotWidth = readNumber('width', 0);
          const slotHeight = readNumber('height', 0);
          const orientation = (marker.getAttribute('data-plate-icons') || 'row').toLowerCase();
          const gapRatio = parseFloat(marker.getAttribute('data-gap')) || 0.1;

          const SVG_NS = 'http://www.w3.org/2000/svg';
          const group = document.createElementNS(SVG_NS, 'g');
          group.setAttribute('data-plate-icons-render', '');

          if (count > 0 && slotWidth > 0 && slotHeight > 0) {
            const isColumn =
              orientation === 'column' || orientation === 'col' || orientation === 'vertical';
            let iconSize;
            if (isColumn) {
              iconSize = Math.min(slotHeight / count, slotWidth) * (1 - gapRatio);
            } else {
              iconSize = Math.min(slotWidth / count, slotHeight) * (1 - gapRatio);
            }
            if (iconSize > 0) {
              const totalWidth = isColumn
                ? iconSize
                : iconSize * count + iconSize * gapRatio * (count - 1);
              const totalHeight = isColumn
                ? iconSize * count + iconSize * gapRatio * (count - 1)
                : iconSize;
              const startX = slotX + (slotWidth - totalWidth) / 2;
              const startY = slotY + (slotHeight - totalHeight) / 2;
              const step = iconSize * (1 + gapRatio);

              handles.forEach((handle, index) => {
                const iconHost = this.cloneIconTemplate(handle);
                if (!iconHost) return;
                const iconRoot = iconHost.querySelector('svg');
                if (!iconRoot) return;

                const iconX = isColumn ? startX : startX + index * step;
                const iconY = isColumn ? startY + index * step : startY;
                group.appendChild(this.embedIconSvg(iconHost, iconRoot, iconX, iconY, iconSize));
              });
            }
          }

          marker.parentNode.replaceChild(group, marker);
        }

        return svgRoot.outerHTML;
      } catch (err) {
        return withTokens;
      }
    }

    refreshPreview() {
      const showVerso = this.currentStep === 'material' && this.state.fixacao;
      const meta = this.modelMeta[this.state.modelHandle] || {};
      const product = this.products[this.state.modelHandle];
      const title = (meta.label || (product && product.title) || '').toString();
      const customSvg = product && typeof product.previewSvg === 'string' ? product.previewSvg : '';
      const hasCustomSvg = customSvg.trim().length > 0;

      if (showVerso && this.previewBack) {
        if (this.previewRender) this.previewRender.hidden = true;
        if (this.previewSvgEl) this.previewSvgEl.hidden = true;
        const entry = this.backSvgsMap.find((m) => m.value === this.state.fixacao);
        const key = entry ? entry.handle : 'fita_dupla_face';
        this.previewBack.classList.remove(
          'plate-render__back--fita_dupla_face',
          'plate-render__back--furos',
          'plate-render__back--lisa'
        );
        this.previewBack.classList.add('plate-render__back--' + key);
        this.previewBack.hidden = false;
        return;
      }

      if (this.previewBack) {
        this.previewBack.hidden = true;
      }

      if (hasCustomSvg && this.previewSvgEl) {
        const rendered = this.applyPreviewSvgPlaceholders(
          customSvg,
          (this.state.text || '').toUpperCase(),
          title.toUpperCase(),
          this.state.selectedIcons
        );
        this.previewSvgEl.innerHTML = rendered;
        this.previewSvgEl.hidden = false;
        if (this.previewRender) this.previewRender.hidden = true;
        return;
      }

      if (this.previewSvgEl) {
        this.previewSvgEl.innerHTML = '';
        this.previewSvgEl.hidden = true;
      }
      if (this.previewRender) this.previewRender.hidden = false;

      if (this.previewTitle) {
        this.previewTitle.textContent = title.toUpperCase();
      }
      if (this.previewHeader) {
        this.previewHeader.style.setProperty('--plate-header-bg', meta.headerBg || '#3b3bdb');
        this.previewHeader.style.setProperty('--plate-header-color', meta.headerColor || '#ffffff');
      }
      if (this.previewBadge) {
        this.previewBadge.classList.remove(
          'plate-render__badge--none',
          'plate-render__badge--ellipse',
          'plate-render__badge--pill'
        );
        const shape = meta.headerShape || 'none';
        this.previewBadge.classList.add('plate-render__badge--' + shape);
        this.previewBadge.style.setProperty('--plate-badge-bg', meta.badgeBg || '#dc2626');
        this.previewBadge.style.setProperty('--plate-badge-color', meta.badgeColor || '#ffffff');
      }
      if (this.previewRender) {
        this.previewRender.style.setProperty('--plate-body-bg', meta.bodyBg || '#ffffff');
        this.previewRender.style.setProperty('--plate-body-color', meta.bodyColor || '#111827');
        const titleScale = (typeof meta.titleSize === 'number' ? meta.titleSize : 100) / 100;
        const textScale = (typeof meta.textSize === 'number' ? meta.textSize : 100) / 100;
        const iconsScale = (typeof meta.iconsSize === 'number' ? meta.iconsSize : 100) / 100;
        this.previewRender.style.setProperty('--plate-title-scale', titleScale);
        this.previewRender.style.setProperty('--plate-text-scale', textScale);
        this.previewRender.style.setProperty('--plate-icons-scale', iconsScale);
      }
      if (this.previewText && document.activeElement !== this.previewText) {
        this.previewText.textContent = (this.state.text || '').toUpperCase();
      }
      this.updateBodyLayout();
      if (this.previewFooter && this.previewFooterText) {
        const footerValue = (meta.footerText || '').trim();
        if (footerValue) {
          this.previewFooterText.textContent = footerValue;
          this.previewFooter.hidden = false;
        } else {
          this.previewFooterText.textContent = '';
          this.previewFooter.hidden = true;
        }
      }
      if (this.previewIcons) {
        this.previewIcons.innerHTML = '';
        this.state.selectedIcons.forEach((handle) => {
          const span = this.cloneIconTemplate(handle);
          if (!span) return;
          const svg = span.querySelector('svg');
          if (svg) {
            svg.removeAttribute('width');
            svg.removeAttribute('height');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          }
          this.previewIcons.appendChild(span);
        });
      }
    }

    renderIcons() {
      if (!this.iconsGrid) return;
      this.iconsGrid.innerHTML = '';

      const product = this.products[this.state.modelHandle];
      const allowed = product && product.allowedIcons && product.allowedIcons.length > 0 ? product.allowedIcons : null;
      const filter = this.state.category && this.state.category !== '*' ? this.state.category : null;

      const visible = this.icons.filter((icon) => {
        if (allowed && allowed.indexOf(icon.handle) === -1) return false;
        if (filter && icon.category !== filter) return false;
        return true;
      });

      this.state.selectedIcons = this.state.selectedIcons.filter((handle) => {
        const icon = this.icons.find((i) => i.handle === handle);
        if (!icon) return false;
        if (allowed && allowed.indexOf(handle) === -1) return false;
        return true;
      });

      this.renderSelectedIcons();

      if (visible.length === 0) {
        if (this.iconsEmpty) this.iconsEmpty.hidden = false;
        this.updateIconsScrollFade();
        return;
      }
      if (this.iconsEmpty) this.iconsEmpty.hidden = true;

      const fragment = document.createDocumentFragment();

      visible.forEach((icon) => {
        const label = document.createElement('label');
        label.className = 'plate-icon-tile blocks-radius';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = icon.handle;
        input.checked = this.state.selectedIcons.indexOf(icon.handle) !== -1;
        if (input.checked) label.classList.add('is-checked');

        input.addEventListener('change', () => {
          if (input.checked) {
            if (this.state.selectedIcons.length >= this.maxIcons) {
              input.checked = false;
              return;
            }
            this.state.selectedIcons.push(icon.handle);
            label.classList.add('is-checked');
          } else {
            this.state.selectedIcons = this.state.selectedIcons.filter((h) => h !== icon.handle);
            label.classList.remove('is-checked');
          }
          this.renderSelectedIcons();
          this.refreshPreview();
        });

        label.appendChild(input);

        const span = this.cloneIconTemplate(icon.handle);
        if (span) {
          span.setAttribute('aria-hidden', 'true');
          const svgEl = span.querySelector('svg');
          if (svgEl) {
            svgEl.removeAttribute('width');
            svgEl.removeAttribute('height');
          }
          label.appendChild(span);
        }

        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = icon.friendlyName || icon.name;
        label.appendChild(sr);

        fragment.appendChild(label);
      });

      this.iconsGrid.appendChild(fragment);
      this.updateIconsScrollFade();
    }

    renderSelectedIcons() {
      if (!this.iconsSelectedGrid || !this.iconsSelected) return;
      this.iconsSelectedGrid.innerHTML = '';

      const selected = this.state.selectedIcons
        .map((handle) => this.icons.find((i) => i.handle === handle))
        .filter(Boolean);

      if (selected.length === 0) {
        this.iconsSelected.hidden = true;
        return;
      }
      this.iconsSelected.hidden = false;

      selected.forEach((icon) => {
        const item = document.createElement('div');
        item.className = 'plate-icons-selected__item';
        item.setAttribute('role', 'listitem');
        item.title = icon.friendlyName || icon.name;

        const wrap = this.cloneIconTemplate(icon.handle);
        if (wrap) {
          wrap.setAttribute('aria-hidden', 'true');
          const svgEl = wrap.querySelector('svg');
          if (svgEl) {
            svgEl.removeAttribute('width');
            svgEl.removeAttribute('height');
          }
          item.appendChild(wrap);
        } else {
          const fallback = document.createElement('span');
          fallback.className = 'plate-icons-selected__fallback';
          fallback.textContent = (icon.friendlyName || icon.name || icon.handle || '').slice(0, 3).toUpperCase();
          item.appendChild(fallback);
        }

        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = icon.friendlyName || icon.name;
        item.appendChild(sr);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'plate-icons-selected__remove';
        removeBtn.innerHTML = '&times;';
        const removeLabelTpl = this.dataset.removeIconLabel || 'Remove __NAME__';
        removeBtn.setAttribute(
          'aria-label',
          removeLabelTpl.replace('__NAME__', icon.friendlyName || icon.name)
        );
        removeBtn.addEventListener('click', () => {
          this.state.selectedIcons = this.state.selectedIcons.filter((h) => h !== icon.handle);
          const checkbox = this.iconsGrid
            ? this.iconsGrid.querySelector('input[type="checkbox"][value="' + icon.handle + '"]')
            : null;
          if (checkbox) {
            checkbox.checked = false;
            const lbl = checkbox.closest('.plate-icon-tile');
            if (lbl) lbl.classList.remove('is-checked');
          }
          this.renderSelectedIcons();
          this.refreshPreview();
        });
        item.appendChild(removeBtn);

        this.iconsSelectedGrid.appendChild(item);
      });
    }

    setOptionInputEnabled(input, enabled) {
      input.disabled = !enabled;
      const label = input.closest('.plate-card, .plate-tab');
      if (label) {
        label.hidden = !enabled;
      }
    }

    updateOptionAvailability() {
      const product = this.products[this.state.modelHandle];
      if (!product || !Array.isArray(product.options) || !Array.isArray(product.variants)) return;

      // Hierarchical order: size narrows material, which narrows fixacao.
      // This keeps every available variant reachable (top-down) while never
      // allowing an invalid combination.
      const types = [
        { key: 'size', selector: '[data-input-size]' },
        { key: 'material', selector: '[data-input-material]' },
        { key: 'fixacao', selector: '[data-input-fixacao]' },
      ].map((type) => ({
        ...type,
        idx: product.options.indexOf(this.optionNames[type.key]),
        inputs: Array.from(this.querySelectorAll(type.selector)),
      }));

      const availableVariants = product.variants.filter(
        (variant) => variant && variant.available && Array.isArray(variant.options)
      );

      // Repair the selection so it maps to a real, available variant, keeping
      // each option valid given the preceding (already resolved) options.
      let candidates = availableVariants.slice();
      types.forEach((type) => {
        if (type.idx === -1 || type.inputs.length === 0) return;
        const valuesInCandidates = new Set(candidates.map((variant) => variant.options[type.idx]));
        if (!valuesInCandidates.has(this.state[type.key])) {
          const firstValid = type.inputs
            .map((input) => input.value)
            .find((value) => valuesInCandidates.has(value));
          if (firstValid != null) {
            this.state[type.key] = firstValid;
            const input = type.inputs.find((candidate) => candidate.value === firstValid);
            if (input) {
              input.checked = true;
              this.markChecked(type.selector, input);
            }
          }
        }
        candidates = candidates.filter((variant) => variant.options[type.idx] === this.state[type.key]);
      });

      // Display: each option shows the values valid given the preceding selections only.
      let displayCandidates = availableVariants.slice();
      types.forEach((type) => {
        if (type.inputs.length === 0) return;
        if (type.idx === -1) {
          type.inputs.forEach((input) => this.setOptionInputEnabled(input, true));
          return;
        }
        const allowed = new Set(displayCandidates.map((variant) => variant.options[type.idx]));
        type.inputs.forEach((input) => {
          this.setOptionInputEnabled(input, allowed.has(input.value));
        });
        displayCandidates = displayCandidates.filter(
          (variant) => variant.options[type.idx] === this.state[type.key]
        );
      });

      this.refreshPreviewSize();
    }

    findVariant() {
      const product = this.products[this.state.modelHandle];
      if (!product) return null;

      const targetOptions = {};
      targetOptions[this.optionNames.size] = this.state.size;
      targetOptions[this.optionNames.material] = this.state.material;
      targetOptions[this.optionNames.fixacao] = this.state.fixacao;

      return product.variants.find((variant) => {
        return product.options.every((optName, idx) => {
          const target = targetOptions[optName];
          if (target == null) return true;
          return variant.options[idx] === target;
        });
      });
    }

    refreshVariant() {
      const variant = this.findVariant();
      if (this.variantIdInput) {
        this.variantIdInput.value = variant ? variant.id : '';
      }
      this.updatePrice(variant);
      this.updateBuyButton(variant);
    }

    formatMoney(amountCents) {
      if (amountCents == null) return '';
      const amount = amountCents / 100;
      const locale = this.currency.currencyCode === 'BRL' ? 'pt-BR' : undefined;
      try {
        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: this.currency.currencyCode || 'BRL',
        });
        return formatter.format(amount);
      } catch (e) {
        return amount.toFixed(2);
      }
    }

    updatePrice(variant) {
      if (!this.priceWrapper) return;
      if (!variant) {
        this.priceWrapper.hidden = true;
        return;
      }
      this.priceWrapper.hidden = false;

      this.syncDiscountTierPrices(variant);

      const activeTier = this.getActiveDiscountTier();
      const basePrice = variant.price;
      const finalPrice = activeTier
        ? Math.round((basePrice * (100 - activeTier.discount)) / 100)
        : basePrice;

      if (this.priceCurrentValue) {
        this.priceCurrentValue.textContent = this.formatMoney(finalPrice);
      }

      if (this.priceCompare && this.priceCompareValue) {
        let compareAt = null;
        if (activeTier) {
          compareAt = basePrice;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareAt = variant.compare_at_price;
        }

        if (compareAt && compareAt > finalPrice) {
          this.priceCompare.hidden = false;
          this.priceCompareValue.textContent = this.formatMoney(compareAt);
        } else {
          this.priceCompare.hidden = true;
        }
      }
    }

    syncDiscountTierPrices(variant) {
      if (!variant || !this.discountsWrapper) return;
      const widget = this.discountsWrapper.querySelector('quantity-discounts');
      if (!widget || typeof widget.setBasePrice !== 'function') return;

      const lastBasePrice = Number(widget.dataset.basePrice || 0);
      if (lastBasePrice === variant.price) return;

      widget.setBasePrice(variant.price, (cents) => this.formatMoney(cents));
    }

    getCurrentQuantity() {
      if (!this.quantityInput) return 1;
      const value = parseInt(this.quantityInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    stepQuantity(delta) {
      if (!this.quantityInput) return;
      const next = Math.max(1, this.getCurrentQuantity() + delta);
      this.quantityInput.value = String(next);
      this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getActiveDiscountTier() {
      const product = this.products[this.state.modelHandle];
      const tiers = product && Array.isArray(product.discountTiers) ? product.discountTiers : null;
      if (!tiers || tiers.length === 0) return null;
      const quantity = this.getCurrentQuantity();
      let active = null;
      tiers.forEach((tier) => {
        const tierQuantity = Number(tier.quantity);
        const tierDiscount = Number(tier.discount);
        if (!Number.isFinite(tierQuantity) || tierQuantity <= 0) return;
        if (!Number.isFinite(tierDiscount) || tierDiscount <= 0) return;
        if (quantity >= tierQuantity) {
          if (!active || tierQuantity > active.quantity) {
            active = { quantity: tierQuantity, discount: tierDiscount };
          }
        }
      });
      return active;
    }

    updateBuyButton(variant) {
      if (!this.buttonBuy) return;
      const available = variant && variant.available;
      this.buttonBuy.disabled = !available;
    }

    setStepProperties() {
      this.state.text = stripPlateEmoji(this.state.text);
      if (this.propTexto) {
        const hasText = this.state.text && this.state.text.trim().length > 0;
        this.propTexto.value = hasText ? this.state.text.trim().toUpperCase() : '';
        this.propTexto.disabled = !hasText;
      }
      if (this.propIcones) {
        const labels = this.state.selectedIcons
          .map((h) => {
            const icon = this.icons.find((i) => i.handle === h);
            return icon ? icon.friendlyName || icon.name : null;
          })
          .filter(Boolean);
        this.propIcones.value = labels.join(', ');
        this.propIcones.disabled = labels.length === 0;
      }
      if (this.propHandles) {
        this.propHandles.value = this.state.selectedIcons.join(',');
        this.propHandles.disabled = this.state.selectedIcons.length === 0;
      }
    }

    hasModelSelector() {
      return Boolean(this.modelsTrack);
    }

    canContinueFrom(step) {
      if (step === 'design') return !this.hasModelSelector() || Boolean(this.state.modelHandle);
      if (step === 'size') return Boolean(this.state.size);
      if (step === 'material') return Boolean(this.state.material) && Boolean(this.state.fixacao);
      return true;
    }

    goNext() {
      if (!this.canContinueFrom(this.currentStep)) {
        if (this.currentStep === 'design') this.showModelRequiredError();
        return;
      }
      this.clearError();
      const idx = this.stepOrder.indexOf(this.currentStep);
      if (idx < this.stepOrder.length - 1) {
        this.goToStep(this.stepOrder[idx + 1]);
      }
    }

    goPrev() {
      const idx = this.stepOrder.indexOf(this.currentStep);
      if (idx > 0) {
        this.goToStep(this.stepOrder[idx - 1]);
      }
    }

    goToStep(step) {
      this.currentStep = step;
      this.querySelectorAll('[data-step]').forEach((el) => {
        const isActive = el.dataset.step === step;
        el.hidden = !isActive;
        el.classList.toggle('is-active', isActive);
      });
      this.syncPreviewEditable();
      this.updateStepIndicator();
      this.updateFooter();
      this.refreshPreview();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    updateStepIndicator() {
      const currentIdx = this.stepOrder.indexOf(this.currentStep);
      this.querySelectorAll('[data-step-indicator]').forEach((el) => {
        const step = el.dataset.stepIndicator;
        const idx = this.stepOrder.indexOf(step);
        el.classList.toggle('is-active', idx === currentIdx);
        el.classList.toggle('is-done', idx < currentIdx || (this.purchased && idx === currentIdx));
      });
    }

    updateFooter() {
      const isFirst = this.currentStep === this.stepOrder[0];
      const isLast = this.currentStep === this.stepOrder[this.stepOrder.length - 1];
      this.classList.toggle('is-last-step', isLast);
      if (this.buttonBack) this.buttonBack.hidden = isFirst;
      if (this.backRow) this.backRow.hidden = isFirst;
      if (this.buttonContinue) this.buttonContinue.hidden = isLast;
      if (this.buttonBuy) this.buttonBuy.hidden = !isLast;
      if (this.quantityWrapper) this.quantityWrapper.hidden = !isLast;
      if (this.priceWrapper) this.priceWrapper.hidden = !isLast || !this.findVariant();
      if (this.discountsWrapper) {
        const product = this.products[this.state.modelHandle];
        const hasTiers = product && Array.isArray(product.discountTiers) && product.discountTiers.length > 0;
        this.discountsWrapper.hidden = !isLast || !hasTiers;
      }
      if (isLast) this.refreshVariant();
    }

    showError(message) {
      if (!this.errorMessage || !this.errorWrapper) return;
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
      this.errorWrapper.hidden = false;
    }

    clearError() {
      if (this.modelsCarousel) this.modelsCarousel.classList.remove('has-error');
      if (!this.errorMessage || !this.errorWrapper) return;
      this.errorMessage.textContent = '';
      this.errorMessage.hidden = true;
      this.errorWrapper.hidden = true;
    }

    openWallModal() {
      if (!this.wallModal || !this.wallPlateSlot || !this.previewPlate) return;
      this.wallPlateSlot.innerHTML = '';
      const clone = this.previewPlate.cloneNode(true);
      clone.removeAttribute('data-preview-plate');

      const cloneBack = clone.querySelector('[data-preview-back]');
      const cloneRender = clone.querySelector('[data-preview-render]');
      const cloneSvg = clone.querySelector('[data-preview-svg]');
      const product = this.products[this.state.modelHandle];
      const usingSvg = product && typeof product.previewSvg === 'string' && product.previewSvg.trim().length > 0;
      if (cloneBack) cloneBack.hidden = true;
      if (usingSvg) {
        if (cloneRender) cloneRender.hidden = true;
        if (cloneSvg) cloneSvg.hidden = false;
      } else {
        if (cloneSvg) cloneSvg.hidden = true;
        if (cloneRender) cloneRender.hidden = false;
      }

      this.wallPlateSlot.appendChild(clone);
      this.wallModal.hidden = false;
      document.body.style.overflow = 'hidden';
      const runLayout = () => this.layoutWallPlate();
      if (this.wallImage && this.wallImage.complete && this.wallImage.naturalWidth) {
        runLayout();
      } else if (this.wallImage) {
        this.wallImage.addEventListener('load', runLayout, { once: true });
      }
    }

    closeWallModal() {
      if (!this.wallModal) return;
      this.wallModal.hidden = true;
      document.body.style.overflow = '';
      if (this.wallPlateSlot) this.wallPlateSlot.innerHTML = '';
    }

    layoutWallPlate() {
      if (!this.wallImage || !this.wallPlateSlot) return;
      const dims = this.parseSize(this.state.size);
      if (!dims) return;
      const imageRect = this.wallImage.getBoundingClientRect();
      if (imageRect.width <= 0) return;
      const pxPerCm = imageRect.width / this.wallRealWidthCm;
      const plateWidthPx = dims.w * pxPerCm;
      const plateHeightPx = dims.h * pxPerCm;
      const centerXPx = imageRect.width * (this.wallPlateX / 100);
      const centerYPx = imageRect.height * (this.wallPlateY / 100);
      this.wallPlateSlot.style.width = plateWidthPx + 'px';
      this.wallPlateSlot.style.height = plateHeightPx + 'px';
      this.wallPlateSlot.style.left = centerXPx - plateWidthPx / 2 + 'px';
      this.wallPlateSlot.style.top = centerYPx - plateHeightPx / 2 + 'px';
    }

    /* ---- Revisão de texto (script local) ---- */

    canReviewText() {
      return Boolean(this.reviewTrigger && this.reviewPanel && this.reviewDictUrl);
    }

    showReviewView(name) {
      if (!this.reviewPanel) return;
      Object.keys(this.reviewViews).forEach((key) => {
        this.reviewViews[key].hidden = key !== name;
      });
      this.reviewPanel.hidden = !name;
      this.review.status = name || 'idle';
    }

    setReviewLoading(loading) {
      if (!this.reviewTrigger) return;
      this.reviewTrigger.disabled = loading;
      this.reviewTrigger.classList.toggle('is-loading', loading);
      this.reviewTrigger.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (this.reviewTriggerLabel) {
        const label = loading ? this.reviewTrigger.dataset.loadingLabel : this.reviewTrigger.dataset.idleLabel;
        if (label) this.reviewTriggerLabel.textContent = label;
      }
    }

    flagReviewHint() {
      if (!this.reviewHint) return;
      this.reviewHint.hidden = false;
      if (this._reviewHintTimer) clearTimeout(this._reviewHintTimer);
      this._reviewHintTimer = setTimeout(() => {
        this.reviewHint.hidden = true;
        this._reviewHintTimer = null;
      }, 4000);
    }

    // Carrega o dicionário (assets/plate-review-pt-br.js) uma única vez, no primeiro uso.
    loadReviewDictionary() {
      if (window.PlateReviewDictionary) return Promise.resolve(buildPlateReviewDictionary(window.PlateReviewDictionary));
      if (this.reviewDictPromise) return this.reviewDictPromise;
      this.reviewDictPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timer = setTimeout(() => {
          script.remove();
          reject(new Error('timeout'));
        }, 30000);
        script.async = true;
        script.src = this.reviewDictUrl;
        script.onload = () => {
          clearTimeout(timer);
          const dict = buildPlateReviewDictionary(window.PlateReviewDictionary);
          if (dict) resolve(dict);
          else reject(new Error('invalid dictionary'));
        };
        script.onerror = () => {
          clearTimeout(timer);
          script.remove();
          reject(new Error('load error'));
        };
        document.head.appendChild(script);
      }).catch((error) => {
        this.reviewDictPromise = null;
        throw error;
      });
      return this.reviewDictPromise;
    }

    // Regras extras do lojista (setting "Custom corrections"), uma por linha:
    // "errado:certo" substitui a palavra; uma palavra sozinha é marcada como correta (nunca é alterada).
    getReviewRules() {
      if (this.reviewRules) return this.reviewRules;
      const rules = { map: {}, known: {} };
      const el = this.querySelector('[data-review-rules]');
      let raw = '';
      try {
        raw = el ? JSON.parse(el.textContent || '""') : '';
      } catch (e) {
        raw = '';
      }
      String(raw || '').split(/\r?\n/).forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) return;
        const idx = trimmed.indexOf(':');
        if (idx <= 0) {
          rules.known[plateReviewFold(trimmed)] = trimmed;
          return;
        }
        const from = trimmed.slice(0, idx).trim().toLowerCase();
        const to = trimmed.slice(idx + 1).trim();
        if (from && to) rules.map[from] = to;
      });
      this.reviewRules = rules;
      return rules;
    }

    normalizeReviewText(value) {
      return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toUpperCase();
    }

    sanitizeReviewedText(raw) {
      let value = stripPlateEmoji(String(raw == null ? '' : raw));
      value = value.replace(/\r\n?/g, '\n').replace(/[ \t]+/g, ' ').replace(/ ?\n ?/g, '\n').trim();
      if (this.maxText && value.length > this.maxText) value = value.slice(0, this.maxText).trim();
      return value;
    }

    setPlateText(value) {
      this.state.text = value;
      if (this.textInput) this.textInput.value = value;
      this.updateCounter();
      this.refreshPreview();
    }

    onTextEdited() {
      if (!this.reviewPanel) return;
      if (this.review.status === 'loading') {
        this.review.status = 'cancelled';
        this.setReviewLoading(false);
        return;
      }
      if (this.review.status === 'result' || this.review.status === 'nochange' || this.review.status === 'error') {
        this.showReviewView(null);
      }
    }

    buildReviewNotes(result) {
      const parts = [];
      if (result.changes.length) {
        const label = this.reviewPanel.dataset.notesLabel || '';
        const list = result.changes.slice(0, 6).map((c) => c.from + ' \u2192 ' + c.to).join(', ');
        parts.push((label ? label + ' ' : '') + list + '.');
      }
      if (result.formatChanged && this.reviewPanel.dataset.notesFormat) {
        parts.push(this.reviewPanel.dataset.notesFormat);
      }
      return parts.join(' ');
    }

    async requestTextReview() {
      if (!this.canReviewText()) return;
      if (this.review.status === 'loading') return;

      const original = stripPlateEmoji(this.state.text || '');
      if (!original.trim()) {
        this.showReviewView(null);
        this.flagReviewHint();
        if (this.textInput) this.textInput.focus();
        return;
      }

      this.showReviewView(null);
      const review = { status: 'loading', original, revised: '', notes: '' };
      this.review = review;
      this.setReviewLoading(true);

      let result;
      try {
        const dict = await this.loadReviewDictionary();
        if (this.review !== review || review.status !== 'loading') return;
        result = reviewPlateText(original, this.getReviewRules(), dict);
      } catch (error) {
        if (this.review !== review || review.status !== 'loading') return;
        this.setReviewLoading(false);
        console.warn('[plate-customizer] text review failed', error);
        this.showReviewView('error');
        return;
      }
      this.setReviewLoading(false);

      const revised = this.sanitizeReviewedText(result.revised);
      const changed = revised.length > 0 && this.normalizeReviewText(revised) !== this.normalizeReviewText(original);
      review.revised = revised;
      review.notes = changed ? this.buildReviewNotes(result) : '';

      if (!changed) {
        this.showReviewView('nochange');
        return;
      }

      this.renderReviewComparison(original, revised);
      this.showReviewView('result');
    }

    tokenizeReviewText(value) {
      return String(value || '').split(/\s+/).filter(Boolean);
    }

    diffReviewTokens(a, b) {
      const n = a.length;
      const m = b.length;
      const same = (i, j) => a[i].toUpperCase() === b[j].toUpperCase();
      const table = [];
      for (let i = 0; i <= n; i++) table.push(new Array(m + 1).fill(0));
      for (let i = n - 1; i >= 0; i--) {
        for (let j = m - 1; j >= 0; j--) {
          table[i][j] = same(i, j) ? table[i + 1][j + 1] + 1 : Math.max(table[i + 1][j], table[i][j + 1]);
        }
      }
      const ops = [];
      let i = 0;
      let j = 0;
      while (i < n && j < m) {
        if (same(i, j)) {
          ops.push({ type: 'eq', a: a[i], b: b[j] });
          i++;
          j++;
        } else if (table[i + 1][j] >= table[i][j + 1]) {
          ops.push({ type: 'del', a: a[i] });
          i++;
        } else {
          ops.push({ type: 'ins', b: b[j] });
          j++;
        }
      }
      while (i < n) ops.push({ type: 'del', a: a[i++] });
      while (j < m) ops.push({ type: 'ins', b: b[j++] });
      return ops;
    }

    renderReviewDiff(el, ops, side) {
      if (!el) return;
      el.textContent = '';
      let first = true;
      ops.forEach((op) => {
        if (side === 'original' && op.type === 'ins') return;
        if (side === 'revised' && op.type === 'del') return;
        const word = side === 'original' ? op.a : op.b;
        if (!first) el.appendChild(document.createTextNode(' '));
        first = false;
        if (op.type === 'eq') {
          el.appendChild(document.createTextNode(word));
          return;
        }
        const node = document.createElement(op.type === 'del' ? 'del' : 'mark');
        node.className = op.type === 'del' ? 'plate-review__del' : 'plate-review__ins';
        node.textContent = word;
        el.appendChild(node);
      });
    }

    renderReviewComparison(original, revised) {
      const ops = this.diffReviewTokens(this.tokenizeReviewText(original), this.tokenizeReviewText(revised));
      this.renderReviewDiff(this.reviewOriginalEl, ops, 'original');
      this.renderReviewDiff(this.reviewRevisedEl, ops, 'revised');
      if (this.reviewNotesEl) {
        this.reviewNotesEl.textContent = this.review.notes;
        this.reviewNotesEl.hidden = !this.review.notes;
      }
    }

    applyReviewedText() {
      if (this.review.status !== 'result' || !this.review.revised) return;
      this.setPlateText(this.review.revised);
      this.showReviewView('applied');
      if (this.textInput) this.textInput.focus();
    }

    keepOriginalText() {
      this.showReviewView(null);
    }

    restoreOriginalText() {
      if (this.review.status !== 'applied') return;
      this.setPlateText(this.review.original);
      this.showReviewView(null);
      if (this.textInput) this.textInput.focus();
    }

    handleSubmit(event) {
      this.clearError();
      this.state.text = stripPlateEmoji(this.state.text);
      if (this.hasModelSelector() && !this.state.modelHandle) {
        event.preventDefault();
        this.showModelRequiredError();
        return;
      }
      const variant = this.findVariant();
      if (!variant || !variant.available) {
        event.preventDefault();
        this.showError(this.dataset.errorUnavailable);
        return;
      }
      if (!this.state.text || this.state.text.trim().length === 0) {
        event.preventDefault();
        this.showError(this.dataset.errorText);
        if (this.textInput) this.textInput.focus();
        return;
      }
      this.setStepProperties();
      this.purchased = true;
      this.updateStepIndicator();
    }
  }

  if (!customElements.get('plate-customizer')) {
    customElements.define('plate-customizer', PlateCustomizer);
  }

  } catch(e) { console.error(e); }
})();
})();
